import React, {useEffect, useRef, useState} from "react";
import FailedModal from "../../../CustomModal/Failed";
import Loader from "../../../../Loader/Loader";
import DashboardMenu from "../../../layout/dashboardMenu";
import Header from "../../../layout/header";
import FileUpload from "../../../FileUploads/FileUpload";
import useLatLng from "../../../../hooks/uselatlng/uselatlng";
import { toast } from "react-toastify";
import DistanceCalculator from "../../../DistanceCalculator/Calculator";
import Moment from "moment";
import DropDownInput from "../../../Input/dropDownInput/dropDownInput";
import SuccessModal from "../../../CustomModal/Success";
import useSiteDistance from "../../../../hooks/currentlocation/useSiteDistance";
import DistanceCalculatorV2 from "../../../DistanceCalculatorV2";
import distanceBetweenTwoPoints from "../../../DistanceBetweenTwoPoints";
import {generateRandomString} from "../../../Common";
import {fireEvent} from "../../../MoEngage";
import {versionCheck} from "../../../Common";
import { CHECK_IN_URL, CHECK_OUT_URL, isNewLeadX } from "../../../../utils/redirection";

const CompleteActivity = ({
                            documentUploadUrlPublic,
                            documentUrlDataPublic,
                            history,
                            match,
                            markAttendances,
                            markAttendanceDetails = [],
                            activityTypesDetails = [],
                            activityTypes,
                            newActivity,
                            NewActivityDetails = [],
                            getActivityDetails = [],
                            userCheckout,
                            isCheckoutDetails = [],
                            getActivity,
                            dealerById,
                            dealerByIdDetails,
                            getSenior,
                            senior = [],
                            addTaggedAlong,
                            addedTaggedAlong = [],
                            getJourney,
                            getUserJourney = [],
                            errorLogs
                          }) => {
  var now = new Date();
  now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
  const islatlng = useLatLng();
  let siteDistance = useSiteDistance(
      dealerByIdDetails?.data?.latitude,
      dealerByIdDetails?.data?.longitude
  )
  const currentUserLocation = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isFailedModalOpen, setIsFailedModalOpen] = useState(false);
  const [countToOpenModal, setCountToOpenModal] = useState(0);
  const [mapLocation, setMapLocation] = useState({
    address: "Delhi",
    lat: 0,
    lng: 0,
  });
  const [isAllow, setIsAllow] = useState(false);
  const [inputList, setInputList] = useState([
    {
      meta_data: {},
      lat: "",
      long: "",
      activity_type_id: "",
      activity_date: "",
      description: "",
      checked: "",
      attendance_id: "",
      module_type: "",
      dealer_id: "",
      dealer_type: "",
      purpose_of_visit: {},
      next_activity_date: "",
      next_activity_type_id: "",
      client_stage: [{}],
      meeting_outcome: [{}, {}, {}],
      designation: [{}]
    },
  ]);
  const [openCheckIn, setOpenCheckIn] = useState(false);
  const [isActivityCreated, setIsActivityCreated] = useState(false);
  // const [purposeOfVisit, setPurposeOfVisit] = useState([{visit_purpose: ''}])
  const [pitched, setPitched] = useState([
    { pitched: "",
      outcome: "",
      outcomeStage: "",
      remark: "",
      reasonNotInterested: "",
      competitorName: "",
      tagCost: "",
      payout: "",
      activationProcess: ""
    }]);
  const [pitchedService, setPitchedService] = useState([{ pitched: "", stage: ""}]);
  const [pitchedChurn, setPitchedChurn] = useState([{ pitched: "" }]);
  const [followupMeeting, setFollowupMeeting] = useState("");
  const [checkInText, setCheckInText] = useState("");
  const [clientStage, setClientStage] = useState();
  const [isClosureStage, setIsClosureStage] = useState(false);
  const [taskInputList, setTaskInputList] = useState([
    { name: "Follow-up Meeting", description: "", task_date: "", checked: ""},
  ]);
  const [accountId, setAccountId] = useState("");
  const [distance, setDistance] = useState();
  const [currentDate, setCurrentDate] = useState(
      now.toISOString().slice(0, 16)
  );
  const [productOutcome, setProductOutcome] = useState([]);
  const [workingWithCompetition, setWorkingWithCompetition] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [taggedAlonedReportee, setTaggedAlonedReportee] = useState({});
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [showSelfie, setShowSelfie] = useState(true);
  const [hideCheckIn, setHideCheckIn] = useState(false);
  const [selectedStage, setSelectedStage] = useState("");
  const [deviceId, setDeviceId] = useState('')
  const [isMockLocation, setIsMockLocation] = useState(false)
  const [userId, setUserId] = useState('')
  const [isLocationFetching, setIsLocationFetching] = useState(false);
  const [locationStatus, setLocationStatus] = useState(null);
  const [appVersion, setAppVersion] = useState(null);

  useEffect( async () => {
    const webView = window.localStorage?.webview;
    setAppVersion(window.localStorage?.app_version);
    if(versionCheck('3.0.0')){
      if(webView !== undefined && webView == 'true') {
        setIsLocationFetching(true);
        getUserLocation();
      } else {
        setIsLoading(true);
        setLocationStatus('granted');
        currentUserLocation.current = await getLocation();
        setIsLocationFetching(false);
        setIsLoading(false)
      }
    }
  }, []);

  function locationCallback(data) {
    if (data.detail) {
      if (data?.detail?.gps_status === "granted") {
        if (data.detail.status === "granted") {
          setLocationStatus("granted");
          currentUserLocation.current = {
            lat: data?.detail?.latitude,
            long: data?.detail?.longitude,
            is_mock: data.detail.mocked,
            device_id: data.detail.device_id
          }
        } else {
          setLocationStatus("permission_denied");
        }
      } else {
        setLocationStatus("gps_denied");
      }
    }
    setIsLocationFetching(false);
  }

  const getUserLocation = () => {
    let eventName = `locationEvent${generateRandomString()}`;
    window.addEventListener(eventName, locationCallback)
    window.ReactNativeWebView.postMessage(JSON.stringify({
      event_name: "get_current_location",
      data: {
        accuracy: 4,
        callback_script: `
            try {
                window.dispatchEvent(new CustomEvent('${eventName}', {detail: {
                    gps_status: "__gps_status__",
                    status: "__status__",
                    mocked: __mocked__,
                    latitude: __latitude__,
                    longitude: __longitude__,
                    device_id: "__device_id__",
                }}))
            } catch (e) {
                console.warn('could not get error')
            }
        `
      }
    }));
    return () => {
      window.removeEventListener(eventName, locationCallback)
    }
  }

  function getLocation() {

    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.permissions.query({ name: 'geolocation' }).then(permissionStatus => {
          if (permissionStatus.state === 'denied') {
            alert('Please allow location access.');
            setIsLoading(false);
            reject('Location access denied.');
          } else {
            setLocationStatus('granted')
            navigator.geolocation.getCurrentPosition(
                (success) => {
                  if (success?.coords && success.coords.latitude) {
                    const location = {
                      lat: success.coords.latitude,
                      long: success.coords.longitude,
                      is_mock: false,
                      device_id: ''
                    };
                    setIsLoading(false);
                    resolve(location);
                  }
                },
                (error) => {
                  setIsLoading(false);
                  reject(error);
                }
            );
          }
        }).catch(err => {
          setIsLoading(false);
          reject(err);
        });
      } else {
        setIsLoading(false);
        reject('Geolocation not supported.');
      }
    });
    // setIsLoading(false);
  }

  useEffect(() => {

    (async () => {

      fireEvent('debugging_event', {
        page: window.location?.pathname,
        is_page_loading_start: 'start',
        type: 'page_loading'
      });
      window.localStorage.module_type = 'dealer';
      setUserId(window.localStorage.user_id)
      setIsLoading(true);
      Promise.all([
        getActivity(match?.params?.module_id, true),
        activityTypes(),
        userCheckout(match?.params?.module_id),
        dealerById(match?.params?.module_id, "ncd"),
        getSenior(),
        getJourney("dealer"),
      ]).then((data) => {
        setIsLoading(false);
      }).catch((error) => {
        setIsLoading(false);
      });
      // setIsLoading(false);
    })();
    if (
        match?.params?.is_edit !== undefined &&
        parseInt(match?.params?.is_edit) === 1
    ) {
      setIsEdit(true);
    }

    fireEvent('debugging_event', {
      page: window.location?.pathname,
      is_page_loading_start: 'finished',
      type: 'page_loading'
    });
  }, []);


  useEffect(() => {
    // after check in hide popup
    if (markAttendanceDetails && markAttendanceDetails?.data !== undefined && markAttendanceDetails?.status === 200) {
      toast.success("Attendance is marked successfully")
      window.location.href = `dealer-activity-list/${match?.params?.module_id}`
    }else if(markAttendanceDetails && markAttendanceDetails?.data !== undefined && markAttendanceDetails?.status !== 200){
      toast.warning(markAttendanceDetails?.message);
      setTimeout(() => {
        window.location.href = `dealer-activity-list/${match?.params?.module_id}`
      }, 1000)
    }
  }, [markAttendanceDetails])

  const handleOutcome = (index, val) => {
    productOutcome[index] = val;
    setProductOutcome(productOutcome);
  };

  const handleWorkingWithCompetition = (index, val) => {
    workingWithCompetition[index] = val;
    setWorkingWithCompetition(workingWithCompetition);
  };

  // const toRad = (Value) => {
  //     return Value * Math.PI / 180
  // }
  //
  // const calcCrow = (lat1, lon1, lat2, lon2) => {
  //     var R = 6371 // km
  //     var dLat = toRad(lat2 - lat1)
  //     var dLon = toRad(lon2 - lon1)
  //     var lat1 = toRad(lat1)
  //     var lat2 = toRad(lat2)
  //
  //     var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
  //         Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2)
  //     var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  //     var d = R * c
  //     return d
  // }

  useEffect(() => {
    setHideCheckIn(false)
    if (dealerByIdDetails && dealerByIdDetails?.data !== undefined && dealerByIdDetails?.data?.longitude !== undefined ) {
      let distance = 0;
      if(versionCheck('3.0.0')){
        if(currentUserLocation?.current?.lat && currentUserLocation?.current?.long){
          distance = distanceBetweenTwoPoints(dealerByIdDetails?.data?.latitude, currentUserLocation?.current?.lat, dealerByIdDetails?.data?.longitude, currentUserLocation?.current?.long);
        }

        if(currentUserLocation.current?.is_mock){
          setIsMockLocation(true)
        }
        if(distance > 0.30 && checkInText === "Check In"){
          // if(parseInt(userId) !== 397){
          console.log("sdfds")
            setHideCheckIn(true)
          // }
        }
        setDistance(parseFloat(distance).toFixed(2))
      }

      setTimeout(() => {
        setIsLoading(true)
        setIsLoading(false)
      }, 1000)
    }
  }, [dealerByIdDetails, currentUserLocation?.current?.lat])

  useEffect(() => {
    // setHideCheckIn(false);
    if (dealerByIdDetails && dealerByIdDetails?.data !== undefined && dealerByIdDetails?.data?.longitude !== undefined ) {
      let distance = 0;
      if(!versionCheck('3.0.0')){
        if(siteDistance?.distance_in_km !== undefined && siteDistance?.distance_in_km !== 'NaN'){
          distance = siteDistance?.distance_in_km * 1000;
        }
        if(distance > 300 && checkInText === "Check In"){
          setHideCheckIn(true)
        }

        setDistance(parseFloat(distance).toFixed(2) + " meter away from site")
      }

      setTimeout(() => {
        setIsLoading(true)
        setIsLoading(false)
      }, 1000)
    }
  }, [dealerByIdDetails, siteDistance])

  useEffect(() => {
    //  if activity is completed then check is either check out or not, if not then open check out popup

    if (getActivityDetails && isCheckoutDetails &&
        isCheckoutDetails?.data !== undefined &&
        getActivityDetails?.data !== undefined
    ) {
      if (getActivityDetails?.data?.activity_type_id !== undefined) {
        let list = [...inputList];
        list[0]["activity_type_id"] =
            getActivityDetails?.data?.activity_type_id;
        list[0]["activity_date"] = getActivityDetails?.data?.activity_date;
        list[0]["id"] = getActivityDetails?.data?.id;
        setAccountId(getActivityDetails?.data?.account_id);
        setInputList(list);
      }

      if (
          isCheckoutDetails?.data?.check_out_lat === null &&
          Object.keys(getActivityDetails?.data).length === 0
      ) {
        setCheckInText("Check out");
        if(isNewLeadX()){
          window.location.replace(CHECK_OUT_URL+`&site_lat=${dealerByIdDetails.data.latitude}`+`&site_long=${dealerByIdDetails.data.longitude}` + `&dealer_id=${dealerByIdDetails.data.dealer_id}`)
        } else {
          setOpenCheckIn(true);
        }
      }

      if (Object.keys(getActivityDetails?.data).length > 0) {
        setIsActivityCreated(true);
      }

      if (
          isCheckoutDetails?.data?.activity_id === undefined &&
          Object.keys(getActivityDetails?.data).length > 0
      ) {
    
        setCheckInText("Check In");
          if(isNewLeadX()){
            window.location.replace(CHECK_IN_URL+`&site_lat=${dealerByIdDetails.data.latitude}`+`&site_long=${dealerByIdDetails.data.longitude}` + `&dealer_id=${dealerByIdDetails.data.dealer_id}`)
          } else {
             setOpenCheckIn(true);
          }
        }
            
    } else {
      // window.location.href = ""
    }
  }, [isCheckoutDetails, getActivityDetails]);

  // const handlePurposeOfVisit = (val, i) => {
  //     let list = [...purposeOfVisit]
  //     list[i]['visit_purpose'] = val
  //     setPurposeOfVisit(list)
  // }
  //
  //
  // const handleAddPurposeOfVisit = () => {
  //     setPurposeOfVisit([
  //         ...purposeOfVisit,
  //         {visit_purpose: ''}
  //     ])
  // }
  //
  // const handleRemovePurposeOfVisit = (e, index) => {
  //     const list = [...purposeOfVisit]
  //     list.splice(index, 1);
  //     setPurposeOfVisit(list);
  //     e.preventDefault()
  // }
  //
  const handlePitched = (val, value, i) => {
    let list = [...pitched];
    list[i][val] = value;
    setPitched(list);
    console.log("pitched:", list);
  };

  const handleAddPitched = () => {
    setPitched([...pitched, { pitched: ""}]);
  };

  const handleRemovePitched = (e, index) => {
    const list = [...pitched];
    list.splice(index, 1);
    setPitched(list);
    e.preventDefault();
  };

  const handlePitchedService = (val, value, i) => {
    let list = [...pitchedService];
    list[i][val] = value;
    setPitchedService(list);
  };

  const handleAddPitchedService = (i) => {
    setPitchedService([...pitchedService, { pitched: "", stage: ""}]);
  };

  // const handleAddPitchedService = (i) => {
  //   const newPitchedService = [...pitchedService];
  //   newPitchedService.splice(i + 1, 0, { pitched: "", stage: "" });
  //   setPitchedService(newPitchedService);
  // };

  const handleRemovePitchedService = (e, index) => {
    const list = [...pitchedService];
    list.splice(index, 1);
    setPitchedService(list);
    e.preventDefault();
  };

  const handlePitchedChurn = (val, value, i) => {
    let list = [...pitchedChurn];
    list[i][val] = value;
    setPitchedChurn(list);
  };

  const handleAddPitchedChurn = () => {
    setPitchedChurn([...pitchedChurn, { pitched: ""}]);
  };

  const handleRemovePitchedChurn = (e, index) => {
    const list = [...pitchedChurn];
    list.splice(index, 1);
    setPitchedChurn(list);
    e.preventDefault();
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    let list = inputList[0];
    if (list["activity_type_id"] === "") {
      toast.error("Please choose activity type");
      return false;
    }

    list["activity_date"] = currentDate;
    if (list["activity_date"] === "") {
      toast.error("Please choose activity date");
      return false;
    }

    list['module_type'] = 'dealer'
    list['dealer_id'] = match?.params?.module_id
    list['dealer_type'] = match?.params?.dealer_type
    if(!versionCheck('3.0.0')){
      list['lat'] = siteDistance?.curr_lat ?? islatlng?.lat
      list['long'] = siteDistance?.curr_long ?? islatlng?.lng
    } else {
      list['lat'] = currentUserLocation?.current?.lat
      list['long'] = currentUserLocation?.current?.long
    }

    list["module_type"] = "dealer";
    list["new_dealer"] = pitched;
    list["service_dealer"] = pitchedService;
    list["churn_dealer"] = pitchedChurn;
    list["pitched"] = [{'new_dealer':pitched, 'service_dealer':pitchedService, 'churn_dealer':pitchedChurn}];


    if (list["long"] == null || list["lat"] == null) {
      toast.error("Please enable your location");
      return false;
    }

    if (!isActivityCreated && list["activity_type_id"] !== "") {
      toast.error("No pending activity! Create new one.");
      return false;
    }

    // if(list['meta_data']['MOM'] !== undefined && list['meta_data']['MOM'].split("").length < 150){
    //   toast.warning("Mom must be minimum 150 characters")
    //   return false
    // }
    if (list?.meta_data?.MOM !== undefined && list?.meta_data?.MOM.length < 70) {
      toast.warning("MOM must be minimum 70 characters");
      return false;
    }
    // list["pitched"] = pitched;
    // list['purpose_of_visit'] = purposeOfVisit
    list["account_id"] = accountId;
    if (followupMeeting === "yes") {
      let task = [...taskInputList];
      list["task_details"] = task[0];
    }
    // console.log("listlistlistlist " + JSON.stringify(list))
    // return false
    setIsLoading(true);
    await newActivity(list);
    setIsLoading(false);
  };

  const handleInput = (key, val, metaKey, e, i = 0) => {
    let list = [...inputList];
    if (key === "meta_data") {
      if (e.target !== undefined && e.target.selectedOptions !== undefined) {
        let desc = e.target.selectedOptions[0].text;
        inputList[0][key][metaKey] = desc;
        inputList[0][key][metaKey + "_id"] = val;
      } else {
        inputList[0][key][metaKey] = val;
      }
    } else if (key === "client_stage") {
      if (metaKey === "stage") {
        inputList[0][key][i] = { stage: val };
      } else {
        inputList[0][key][i] = { closure_stage: val };
      }
    } else if (metaKey === "designation") {
      if (
          inputList[0][metaKey][i]["designation"] !== undefined &&
          inputList[0][metaKey][i]["designation"] !== val &&
          key === "Other"
      ) {
        inputList[0][metaKey][i] = {};
      }
      if (
          inputList[0][metaKey][i]["Other"] !== undefined &&
          inputList[0][metaKey][i]["Other"] !== val &&
          key === "Other"
      ) {
        delete inputList[0][metaKey][i]["Designation"];
        delete inputList[0][metaKey][i]["Name"];
        delete inputList[0][metaKey][i]["Mobile Number"];
        delete inputList[0][metaKey][i]["Email"];
      }
      inputList[0][metaKey][i][key] = val;
    } else if (metaKey === "meeting_outcome") {
      if (
          inputList[0][metaKey][i]["Outcome"] !== undefined &&
          inputList[0][metaKey][i]["Outcome"] !== val &&
          key === "Outcome"
      ) {
        inputList[0][metaKey][i] = {};
      }

      if (
          inputList[0][metaKey][i]["Remark"] !== undefined &&
          inputList[0][metaKey][i]["Remark"] !== val &&
          key === "Remark"
      ) {
        delete inputList[0][metaKey][i]["Not Satisfied With Experience Remark"];
        delete inputList[0][metaKey][i]["Competitior Name"];
        delete inputList[0][metaKey][i]["Tag Cost"];
        delete inputList[0][metaKey][i]["Activation Process"];
        delete inputList[0][metaKey][i]["Payout"];
      }
      // inputList[0][metaKey][i] = {}
      inputList[0][metaKey][i][key] = val;
    } else {
      inputList[0][key] = val;
    }
    setInputList(list);
  };

  const handleAddPOC = (index) => {
    const updatedList = [...inputList];
    updatedList[0].designation.push({ designation: "", name: "", mobile_number: "", email: "" });
    setInputList(updatedList);
  };

  const handleRemovePOC = (index,e) => {
    const updatedList = [...inputList];
    updatedList[0].designation.pop();
    setInputList(updatedList);

  };

  const handleTaskInput = (key, val, e) => {
    e.preventDefault();
    let list = [...taskInputList];
    list[0][key] = val;
    setTaskInputList(list);
  };

  useEffect(() => {
    // show check out after complete activity
    if (NewActivityDetails &&
        NewActivityDetails?.data !== undefined &&
        NewActivityDetails?.status === 200
    ) {
     if(isNewLeadX()){
          window.location.replace(CHECK_OUT_URL+`&site_lat=${dealerByIdDetails.data.latitude}`+`&site_long=${dealerByIdDetails.data.longitude}` + `&dealer_id=${dealerByIdDetails.data.dealer_id}`)
        } else {
          setOpenCheckIn(true);
        }
      setCheckInText("Check out");
      setShowSelfie(false);
      setMessage(NewActivityDetails?.message);
    } else if (
        NewActivityDetails?.data !== undefined &&
        NewActivityDetails?.status !== 200
    ) {
      setCountToOpenModal(countToOpenModal + 1);
      setIsFailedModalOpen(true);
      setMessage(NewActivityDetails?.message);
    }
  }, [NewActivityDetails]);

  const handleUpdateTaggedAlong = async (e) => {
    e.preventDefault();
    let values = [];
    if (
        taggedAlonedReportee !== [] &&
        taggedAlonedReportee !== "" &&
        taggedAlonedReportee.length > 0
    ) {
      taggedAlonedReportee.map((val, i) => {
        values[i] = val.id;
      });
    }

    if (values === []) {
      toast.error("Please select tagged along");
      return false;
    }

    setIsLoading(true);
    await addTaggedAlong({
      tagged_along: values,
      id: getActivityDetails?.data?.id,
      is_edit: true,
    });
    setIsLoading(false);
  };

  useEffect(() => {
    setIsFailedModalOpen(false);
    setIsSuccessModalOpen(false);
    if (addedTaggedAlong && addedTaggedAlong?.status === 200) {
      setIsSuccessModalOpen(true);
      setMessage(addedTaggedAlong?.message);
    } else if ( addedTaggedAlong &&
        addedTaggedAlong?.status !== undefined &&
        addedTaggedAlong?.status !== 200
    ) {
      setCountToOpenModal(countToOpenModal + 1);
      setIsFailedModalOpen(true);
      setMessage(addedTaggedAlong?.message);
    }
  }, [addedTaggedAlong]);

  useEffect(() => {
    if (
        getUserJourney &&
        getUserJourney?.data &&
        typeof getUserJourney?.data === "object" &&
        Object.keys(getUserJourney?.data).length > 0
    ) {
      if (
          isCheckoutDetails &&
          getActivityDetails &&
          isCheckoutDetails?.data?.check_out_lat === null &&
          getActivityDetails?.data &&
          typeof getActivityDetails?.data === "object" &&
          Object.keys(getActivityDetails?.data).length === 0
      ) {
         if(isNewLeadX()){
          window.location.replace(CHECK_IN_URL+`&site_lat=${dealerByIdDetails.data.latitude}`+`&site_long=${dealerByIdDetails.data.longitude}` + `&dealer_id=${dealerByIdDetails.data.dealer_id}`)
        } else {
          setOpenCheckIn(true);
        }
        setCheckInText("Check In");
      }
    } else if (getUserJourney && getUserJourney?.data !== undefined) {
      toast.warning("You have not started your journey yet for today");
      setTimeout(() => {
        window.location.href = `dealer-activity-list/${match?.params?.module_id}`;
      }, 1000);
    }
  }, [getUserJourney]);

  useEffect(() => {
    if(isMockLocation){
      setOpenCheckIn(false)
      setHideCheckIn(true)
      // toast.error('Location morphing is cheating. Check in not allowed');
      handleErrorLogsSave(`Location morphing is cheating. ${checkInText} not allowed`, checkInText);
      setCountToOpenModal(countToOpenModal+1);
    }
  }, [isMockLocation])

  const handleErrorLogsSave = async (msg, type) => {
    setIsLoading(true)
    await errorLogs({
      module_type:"Dealer",
      message: msg,
      type: type,
      device_id: window.localStorage.device_id ?? null
    })
    setIsLoading(false)
  }

  const refreshUserLocation = async (e) => {
    e.preventDefault();
    const webView = window.localStorage?.webview;
    if(webView !== undefined && webView == 'true') {
      setIsLocationFetching(true);
      getUserLocation();
    } else {
      setIsLoading(true);
      setIsLocationFetching(true);
      currentUserLocation.current = await getLocation();
      setIsLocationFetching(false);
      setIsLoading(false);
    }
  }

  return (
      <>
        <SuccessModal
            isOpen={isSuccessModalOpen}
            msg={message}
            url={`dealer-activity-list/${match?.params?.module_id}`}
        />

        <FailedModal
            isOpen={isFailedModalOpen}
            msg={message}
            countToOpenModal={countToOpenModal}
        />

        {isMockLocation &&
            <FailedModal
                isOpen={isMockLocation}
                msg={`Location morphing is cheating. ${checkInText} not allowed`}
                countToOpenModal={countToOpenModal}
                url={`dealer-activity-list/${match?.params?.module_id}`}
            />
        }
        <Loader isLoading={isLoading} />

        <div id="wrapper">
          <DashboardMenu />
          <div id="content-wrapper" className="d-flex flex-column">
            <div id="content">
              <Header title={"Activity"} history={history} />
              {/*BODY*/}

              <div className="container-fluid common-bg">
                {isEdit ? (
                    <>
                      <form onSubmit={(e) => handleUpdateTaggedAlong(e)}>
                        <div className="row">
                          <div className="col-md-12">
                            {!versionCheck('3.0.0') ?
                                <div
                                    className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                  <h1 className="h3 mb-0 text-black-100">
                                    {/*<b>{getActivityDetails?.data?.name !== undefined ? getActivityDetails?.data?.name : "Close Activity"}</b>*/}
                                    <span style={{color: "green"}}> {distance}</span>
                                  </h1>
                                </div> :
                                <div
                                    className="d-flex align-items-center justify-content-between com-sub-heading">
                                  {isLocationFetching ? "Location fetching..." : ""}
                                  {locationStatus === "granted" && currentUserLocation?.current?.lat ?
                                      <span
                                          style={{color: "green"}} className="ml-5">{distance + " km away from site"}
                                                            </span> :
                                      <h1 className="h3 mb-0 text-black-100">
                                        {/*<b>{getActivityDetails?.data?.name !== undefined ? getActivityDetails?.data?.name : "Close Activity"}</b>*/}
                                        <span
                                            style={{color: "green"}}
                                            className="ml-5"> You've denied GPS/permission, please allow it and then relaunch the
                                            application</span>
                                      </h1>
                                  }
                                  <button className="btn btn-primary mr-4" onClick={(e) => {
                                    refreshUserLocation(e)
                                  }}><i className="bi bi-arrow-clockwise f-20px"></i></button>
                                </div>
                            }

                            {/*<div className="mb-0 bg-white">*/}
                            <div className="card-body bg-white">
                              <div className="user">
                                <div className="form-group row">
                                  <div className="col-sm-6 mt-1 float-field">
                                    <select
                                        className="form-control form-control-user"
                                        onChange={(e) => {
                                          handleInput(
                                              "activity_type_id",
                                              e.target.value,
                                              e
                                          );
                                        }}
                                        disabled={true}
                                    >
                                      <option value="">Select Activity</option>
                                      {activityTypesDetails?.data !== undefined &&
                                          activityTypesDetails?.data.map((val) => {
                                            return (
                                                <>
                                                  {getActivityDetails?.data
                                                      ?.activity_type_id !== undefined &&
                                                  getActivityDetails?.data
                                                      ?.activity_type_id ===
                                                  parseInt(val?.id) ? (
                                                      <option
                                                          value={val?.id}
                                                          selected={true}
                                                      >
                                                        {val.name}
                                                      </option>
                                                  ) : (
                                                      <option value={val?.id}>
                                                        {val.name}
                                                      </option>
                                                  )}
                                                </>
                                            );
                                          })}
                                    </select>
                                    <label className="large-label float-lb">
                                      Activity Type
                                    </label>
                                  </div>

                                  {getActivityDetails?.data?.tagged_approved !==
                                      undefined &&
                                      getActivityDetails?.data?.tagged_approved !==
                                      [] &&
                                      getActivityDetails?.data?.tagged_approved !==
                                      "" && (
                                          <div className="col-sm-6 mtk-075 float-field mb-4">
                                            <label
                                                className="large-label"
                                                style={{ color: "#1b7cef" }}
                                            >
                                              Accepted Tagged Along
                                            </label>
                                            <textarea
                                                className="form-control form-control-user"
                                                placeholder=" "
                                                onChange={(e) => {
                                                  // handleInput('Not Satisfied With Experience Remark', e.target.value, 'meeting_outcome', e, i)
                                                }}
                                                id="validationCustom01"
                                                rows="4"
                                                cols="50"
                                                value={
                                                  getActivityDetails?.data
                                                      ?.tagged_approved
                                                }
                                                disabled={true}
                                            />
                                          </div>
                                      )}
                                  <div className="col-sm-6 mtk-075 float-field mb-4">
                                    <DropDownInput
                                        data={senior}
                                        label={"Tagged Along"}
                                        getIdValue={(val) => {
                                          setTaggedAlonedReportee(val);
                                        }}
                                        multipule={true}
                                        selectedList={
                                          getActivityDetails?.data?.tagged_users
                                        }
                                    />
                                  </div>
                                  <div className="col-sm-6 mtk-075 float-field">
                                    <input
                                        type="datetime-local"
                                        className="form-control form-control-user"
                                        placeholder=" "
                                        onChange={(e) => {
                                          handleInput(
                                              "activity_date",
                                              e.target.value,
                                              e
                                          );
                                          setCurrentDate(e.target.value);
                                        }}
                                        id="validationCustom01"
                                        disabled={true}
                                        value={
                                          getActivityDetails?.data?.activity_date !==
                                          undefined
                                              ? getActivityDetails?.data?.activity_date
                                              : ""
                                        }
                                        max={
                                            new Date().toISOString().split("T")[0] +
                                            "T00:00"
                                        }
                                        // value={currentDate}
                                    />
                                    <label className="large-label float-lb">
                                      Activity Date
                                    </label>
                                  </div>

                                  {getActivityDetails?.data?.purpose_of_visit !==
                                      undefined &&
                                      getActivityDetails?.data?.purpose_of_visit !==
                                      null &&
                                      getActivityDetails?.data?.purpose_of_visit
                                          .length > 0 &&
                                      getActivityDetails?.data?.purpose_of_visit.map(
                                          (val, i) => {
                                            return (
                                                <>
                                                  {val?.visit_purpose !== null && (
                                                      <>
                                                        <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                          <input
                                                              type="text"
                                                              className="form-control form-control-user"
                                                              placeholder=" "
                                                              onChange={(e) => {
                                                                // handlePocInput(e.target.value, 'city', i)
                                                              }}
                                                              value={val?.visit_purpose}
                                                              disabled={true}
                                                          />
                                                          <label className="large-label float-lb">
                                                            Purpose of Visit
                                                          </label>
                                                        </div>
                                                        {(val?.visit_purpose ===
                                                                "New Product" ||
                                                                val?.visit_purpose ===
                                                                "New Dealer") &&
                                                            getActivityDetails?.data
                                                                ?.pitched !== undefined &&
                                                            getActivityDetails?.data
                                                                ?.pitched !== null &&
                                                            getActivityDetails?.data?.pitched
                                                                .length > 0 &&
                                                            getActivityDetails?.data?.pitched.map(
                                                                (val, i) => {
                                                                  return (
                                                                      <>
                                                                        {val?.pitched !== null &&
                                                                            val?.pitched !==
                                                                            undefined && (
                                                                                <>
                                                                                  <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control form-control-user"
                                                                                        placeholder=" "
                                                                                        onChange={(
                                                                                            e
                                                                                        ) => {
                                                                                          // handlePocInput(e.target.value, 'city', i)
                                                                                        }}
                                                                                        value={
                                                                                          val?.pitched
                                                                                        }
                                                                                        disabled={true}
                                                                                    />
                                                                                    <label className="large-label float-lb">
                                                                                      Pitched
                                                                                    </label>
                                                                                  </div>

                                                                                  {/* <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                              <input
                                                                type="text"
                                                                className="form-control form-control-user"
                                                                placeholder=" "
                                                                onChange={(
                                                                  e
                                                                ) => {
                                                                  // handlePocInput(e.target.value, 'city', i)
                                                                }}
                                                                value={
                                                                  val?.status
                                                                }
                                                                disabled={true}
                                                              />
                                                              <label className="large-label float-lb">
                                                                Status
                                                              </label>
                                                            </div> */}
                                                                                </>
                                                                            )}
                                                                      </>
                                                                  );
                                                                }
                                                            )}
                                                      </>
                                                  )}
                                                </>
                                            );
                                          }
                                      )}
                                </div>
                              </div>
                            </div>
                          </div>
                          {/*</div>*/}
                          <div className="col-md-12 mt-4 d-flex">
                            <button className="btn btn-primary btn-user btn-block submit-btn">
                              Submit
                            </button>
                          </div>
                        </div>
                      </form>
                    </>
                ) : (
                    <>
                      {openCheckIn ? (
                          <div className="popup-box">
                            <div className="box">
                              {!versionCheck('3.0.0') ?
                                  <DistanceCalculator
                                      isMapShow={true}
                                      calculateDistance={markAttendances}
                                      moduleType={"Dealer"}
                                      checkInText={checkInText}
                                      checkoutId={isCheckoutDetails?.data !== undefined ? isCheckoutDetails?.data?.id : 0}
                                      moduleId={match?.params?.module_id}
                                      activityId={
                                        getActivityDetails?.data?.id !== undefined
                                            ? getActivityDetails?.data?.id
                                            : ""
                                      }
                                      documentUploadUrlPublic={documentUploadUrlPublic}
                                      documentUrlDataPublic={documentUrlDataPublic}
                                      showSelfie={showSelfie}
                                      hideCheckButton={hideCheckIn}
                                      distance={distance}
                                      lat={dealerByIdDetails?.data?.latitude}
                                      long={dealerByIdDetails?.data?.longitude}
                                      dealerId={match?.params?.module_id}
                                      deviceId={deviceId}
                                      // deviceIdCheck={true}
                                  />
                                  :
                                  <DistanceCalculatorV2
                                      isMapShow={true}
                                      calculateDistance={markAttendances}
                                      moduleType={"Dealer"}
                                      checkInText={checkInText}
                                      checkoutId={isCheckoutDetails?.data !== undefined ? isCheckoutDetails?.data?.id : 0}
                                      moduleId={match?.params?.module_id}
                                      activityId={
                                        getActivityDetails?.data?.id !== undefined
                                            ? getActivityDetails?.data?.id
                                            : ""
                                      }
                                      documentUploadUrlPublic={documentUploadUrlPublic}
                                      documentUrlDataPublic={documentUrlDataPublic}
                                      showSelfie={showSelfie}
                                      hideCheckButton={hideCheckIn}
                                      distance={distance}
                                      lat={dealerByIdDetails?.data?.latitude}
                                      long={dealerByIdDetails?.data?.longitude}
                                      dealerId={match?.params?.module_id}
                                      deviceId={deviceId}
                                      // deviceIdCheck={true}
                                  />
                              }

                            </div>
                          </div>
                      ) : (
                          <>
                            <form onSubmit={(e) => handleSubmit(e)}>
                              <div className="row">
                                <div className="col-md-12">
                                  {!versionCheck('3.0.0') ?
                                      <div
                                          className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                        <h1 className="h3 mb-0 text-black-100">
                                          {/*<b>{getActivityDetails?.data?.name !== undefined ? getActivityDetails?.data?.name : "Close Activity"}</b>*/}
                                          <span style={{color: "green"}}> {distance}</span>
                                        </h1>
                                      </div> :
                                      <div
                                          className="d-flex align-items-center justify-content-between com-sub-heading">
                                        {isLocationFetching ? "Location fetching..." : ""}
                                        {locationStatus === "granted" && currentUserLocation?.current?.lat ?
                                            <span
                                                style={{color: "green"}} className="ml-5">{distance + " km away from site"}
                                                            </span> :
                                            <h1 className="h3 mb-0 text-black-100">
                                              {/*<b>{getActivityDetails?.data?.name !== undefined ? getActivityDetails?.data?.name : "Close Activity"}</b>*/}
                                              <span
                                                  style={{color: "green"}}
                                                  className="ml-5"> You've denied GPS/permission, please allow it and then relaunch the
                                            application</span>
                                            </h1>
                                        }
                                        <button className="btn btn-primary mr-4" onClick={(e) => {
                                          refreshUserLocation(e)
                                        }}><i className="bi bi-arrow-clockwise f-20px"></i></button>
                                      </div>
                                  }
                                  {/*<div className="mb-0 bg-white">*/}

                                  <div className="card-body bg-white">
                                    <div className="user">
                                      <div className="form-group row">
                                        <div className="col-sm-6 mt-3 float-field">
                                          <select
                                              className="form-control form-control-user"
                                              onChange={(e) => {
                                                handleInput(
                                                    "activity_type_id",
                                                    e.target.value,
                                                    e
                                                );
                                              }}
                                              disabled={true}
                                          >
                                            <option value="">Select Activity</option>
                                            {activityTypesDetails?.data !==
                                                undefined &&
                                                activityTypesDetails?.data.map(
                                                    (val) => {
                                                      return (
                                                          <>
                                                            {getActivityDetails?.data
                                                                ?.activity_type_id !==
                                                            undefined &&
                                                            getActivityDetails?.data
                                                                ?.activity_type_id ===
                                                            parseInt(val?.id) ? (
                                                                <option
                                                                    value={val?.id}
                                                                    selected={true}
                                                                >
                                                                  {val.name}
                                                                </option>
                                                            ) : (
                                                                <option value={val?.id}>
                                                                  {val.name}
                                                                </option>
                                                            )}
                                                          </>
                                                      );
                                                    }
                                                )}
                                          </select>
                                          <label className="large-label float-lb">
                                            Activity Type
                                          </label>
                                        </div>
                                        <div className="col-sm-6 mt-3 float-field">
                                          <input
                                              type="datetime-local"
                                              className="form-control form-control-user"
                                              placeholder=" "
                                              onChange={(e) => {
                                                handleInput(
                                                    "activity_date",
                                                    e.target.value,
                                                    e
                                                );
                                                setCurrentDate(e.target.value);
                                              }}
                                              id="validationCustom01"
                                              disabled={true}
                                              // value={getActivityDetails?.data?.activity_date !== undefined ? getActivityDetails?.data?.activity_date :""}
                                              max={
                                                  new Date().toISOString().split("T")[0] +
                                                  "T00:00"
                                              }
                                              value={currentDate}
                                          />
                                          <label className="large-label float-lb">
                                            Activity Date
                                          </label>
                                        </div>
                                        {getActivityDetails?.data
                                                ?.purpose_of_visit !== undefined &&
                                            getActivityDetails?.data
                                                ?.purpose_of_visit !== null &&
                                            getActivityDetails?.data?.purpose_of_visit
                                                .length > 0 &&
                                            getActivityDetails?.data?.purpose_of_visit.map(
                                                (val, i) => {
                                                  return (
                                                      <>
                                                        {val?.visit_purpose !== null && (
                                                            <>
                                                              <div className="col-sm-6 mt-1 float-field">
                                                                <input
                                                                    type="text"
                                                                    className="form-control form-control-user"
                                                                    placeholder=" "
                                                                    onChange={(e) => {
                                                                      // handlePocInput(e.target.value, 'city', i)
                                                                    }}
                                                                    value={val?.visit_purpose}
                                                                    disabled={true}
                                                                />
                                                                <label className="large-label float-lb">
                                                                  Purpose of Visit
                                                                </label>
                                                              </div>
                                                              {(val?.visit_purpose ===
                                                                      "New Product" ||
                                                                      val?.visit_purpose ===
                                                                      "New Dealer") &&
                                                                  getActivityDetails?.data
                                                                      ?.pitched !== undefined &&
                                                                  getActivityDetails?.data
                                                                      ?.pitched !== null &&
                                                                  getActivityDetails?.data
                                                                      ?.pitched.length > 0 &&
                                                                  getActivityDetails?.data?.pitched.map(
                                                                      (val, ii) => {
                                                                        return (
                                                                            <>
                                                                              {val?.pitched !==
                                                                                  null &&
                                                                                  val?.pitched !==
                                                                                  undefined && (
                                                                                      <>
                                                                                        <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                                                          <input
                                                                                              type="text"
                                                                                              className="form-control form-control-user"
                                                                                              placeholder=" "
                                                                                              onChange={(
                                                                                                  e
                                                                                              ) => {
                                                                                                // handlePocInput(e.target.value, 'city', i)
                                                                                              }}
                                                                                              value={
                                                                                                val?.pitched
                                                                                              }
                                                                                              disabled={
                                                                                                true
                                                                                              }
                                                                                          />
                                                                                          <label className="large-label float-lb">
                                                                                            Pitched
                                                                                          </label>
                                                                                        </div>

                                                                                        <div className="col-sm-6 mt-1 float-field">
                                                                                          <input
                                                                                              type="text"
                                                                                              className="form-control form-control-user"
                                                                                              placeholder=" "
                                                                                              onChange={(
                                                                                                  e
                                                                                              ) => {
                                                                                                // handlePocInput(e.target.value, 'city', i)
                                                                                              }}
                                                                                              value={
                                                                                                val?.status
                                                                                              }
                                                                                              disabled={
                                                                                                true
                                                                                              }
                                                                                          />
                                                                                          <label className="large-label float-lb">
                                                                                            Status
                                                                                          </label>
                                                                                        </div>
                                                                                      </>
                                                                                  )}
                                                                            </>
                                                                        );
                                                                      }
                                                                  )}
                                                              {(val?.visit_purpose ===
                                                                  "New Product" ||
                                                                  val?.visit_purpose ===
                                                                  "New Dealer") && (
                                                                  <>
                                                                    <div
                                                                        className="col-sm-6 mt-1 float-field"
                                                                        style={{
                                                                          marginTop:
                                                                              "16px !important",
                                                                        }}
                                                                    >
                                                                      <select
                                                                          className="form-control form-control-user"
                                                                          onChange={(e) => {
                                                                            handleInput(
                                                                                "client_stage",
                                                                                e.target.value,
                                                                                "stage",
                                                                                e,
                                                                                i
                                                                            );
                                                                            setIsClosureStage(
                                                                                e.target.value
                                                                            );
                                                                            setSelectedStage(e.target.value);
                                                                          }}
                                                                          required={true}
                                                                      >
                                                                        <option value="">
                                                                          Select Product Stages
                                                                        </option>
                                                                        <option
                                                                            value={
                                                                              "Initial Conversation"
                                                                            }
                                                                        >
                                                                          Initial Conversation
                                                                        </option>
                                                                        <option
                                                                            value={"Negotiation"}
                                                                        >
                                                                          Negotiation
                                                                        </option>
                                                                        <option
                                                                            value={"Proposal"}
                                                                        >
                                                                          Proposal
                                                                        </option>
                                                                        <option
                                                                            value={"Closure"}
                                                                        >
                                                                          Closure
                                                                        </option>
                                                                      </select>
                                                                      <label className="large-label float-lb">
                                                                        New Product Stages
                                                                      </label>
                                                                    </div>
                                                                    <div
                                                                        className="col-sm-6 mtk-075 float-field">
                                                                      <input
                                                                          type="date"
                                                                          className="form-control form-control-user"
                                                                          placeholder=" "
                                                                          onChange={(e) => {
                                                                            handleInput(
                                                                                "meta_data",
                                                                                e.target.value,
                                                                                "tentative_closure_date",
                                                                                e
                                                                            );
                                                                          }}
                                                                          required={selectedStage !== "Initial Conversation"}
                                                                          id="validationCustom01"
                                                                          min={
                                                                            new Date()
                                                                                .toISOString()
                                                                                .split("T")[0]
                                                                          }
                                                                      />
                                                                      <label
                                                                          className="large-label float-lb">
                                                                        Tentative Closure Date
                                                                      </label>
                                                                    </div>

                                                                    {/* new */}
                                                                    <div className="card mt-3">
                                                                      <div className="card-header">
                                                                        <h5 className="card-title">Point of Contacts</h5>
                                                                      </div>
                                                                      <div className="card-body">
                                                                        {inputList[0].designation.map((poc, index) => (
                                                                            <div className="form-group row" key={index}>
                                                                              <div className="col-sm-6 mt-1 float-field">
                                                                                <select
                                                                                    className="form-control form-control-user"
                                                                                    onChange={(e) => handleInput("designation", e.target.value, "designation", e, index)}
                                                                                    required
                                                                                >
                                                                                  <option value="">Select Meeting With</option>
                                                                                  <option value="Owner">Owner</option>
                                                                                  <option value="VP">VP</option>
                                                                                  <option value="GM">GM</option>
                                                                                  <option value="Sale Manager">Sale Manager</option>
                                                                                  <option value="Marketing Manager">Marketing Manager</option>
                                                                                  <option value="RTO Head">RTO Head</option>
                                                                                  <option value="Other">Other</option>
                                                                                </select>
                                                                                <label className="large-label float-lb">Meeting With</label>
                                                                              </div>

                                                                              {poc.designation === "Other" && (
                                                                                  <>
                                                                                    <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                                                      <input
                                                                                          type="text"
                                                                                          className="form-control form-control-user"
                                                                                          placeholder=" "
                                                                                          onChange={(e) => handleInput("Designation", e.target.value, "designation", e, index)}
                                                                                          required
                                                                                      />
                                                                                      <label className="large-label float-lb">Designation</label>
                                                                                    </div>
                                                                                    <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                                                      <input
                                                                                          type="text"
                                                                                          className="form-control form-control-user"
                                                                                          placeholder=" "
                                                                                          onChange={(e) => handleInput("Name", e.target.value, "designation", e, index)}
                                                                                          required
                                                                                      />
                                                                                      <label className="large-label float-lb">Name</label>
                                                                                    </div>
                                                                                    <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                                                      <input
                                                                                          type="text"
                                                                                          className="form-control form-control-user"
                                                                                          placeholder=" "
                                                                                          onChange={(e) => {
                                                                                            const inputValue = e.target.value;
                                                                                            const mobileNumber = inputValue.replace(/\D/g, '');
                                                                                            const trimmedMobileNumber = mobileNumber.slice(0, 10)
                                                                                            e.target.value = trimmedMobileNumber;
                                                                                            handleInput("mobile_number", trimmedMobileNumber, "designation", e, index);
                                                                                          }}
                                                                                          required
                                                                                      />
                                                                                      <label className="large-label float-lb">Mobile Number</label>
                                                                                    </div>
                                                                                    <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                                                      <input
                                                                                          type="email"
                                                                                          className="form-control form-control-user"
                                                                                          placeholder=" "
                                                                                          onChange={(e) => handleInput("Email", e.target.value, "designation", e, index)}
                                                                                          required
                                                                                      />
                                                                                      <label className="large-label float-lb">Email</label>
                                                                                    </div>
                                                                                  </>
                                                                              )}
                                                                            </div>
                                                                        ))}
                                                                        <div className="form-group row">
                                                                          <div className="col-md-12 text-right">
                                                                            {inputList[0].designation.length !== 1 && (
                                                                                <button
                                                                                    onClick={(e) => handleRemovePOC(e, inputList[0].designation.length - 1)}
                                                                                    className="btn btn-sm btn-danger ml-3"
                                                                                >
                                                                                  Remove POC
                                                                                </button>
                                                                            )}
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-sm btn-primary ml-3"
                                                                                onClick={() => handleAddPOC()}
                                                                            >
                                                                              Add POC
                                                                            </button>
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                    </div>

                                                                    {(val?.visit_purpose === "New Product" || val?.visit_purpose === "New Dealer") && pitched.length > 0 && (
                                                                        <div className="card mt-3">
                                                                          <div className="card-header">
                                                                            <h5 className="card-title">Pitched Details</h5>
                                                                          </div>
                                                                          <div className="card-body">
                                                                            {pitched.map((values, ii) => (
                                                                                <>
                                                                                  <div className="form-group row">
                                                                                    <div className="col-md-3">
                                                                                      <select
                                                                                          className="form-control form-control-user"
                                                                                          onChange={(e) => {
                                                                                            handlePitched("pitched", e.target.value, ii);
                                                                                          }}
                                                                                          required
                                                                                      >
                                                                                        <option value="">Select Pitched</option>
                                                                                        <option value="FASTag">FASTag</option>
                                                                                        <option value="Yard Management">Yard Management</option>
                                                                                        <option value="Fuel">Fuel</option>
                                                                                        <option value="Test Drive leads">Test Drive leads</option>
                                                                                        <option value="Driver Management">Driver Management</option>
                                                                                        <option value="Servicing Products-P&D & Discovery">
                                                                                          Servicing Products-P&D & Discovery
                                                                                        </option>
                                                                                      </select>

                                                                                      {/* <label className="large-label float-lb">Pitched For</label> */}

                                                                                    </div>
                                                                                    <div className="col-md-3">
                                                                                      <select
                                                                                          className="form-control form-control-user"
                                                                                          onChange={(e) => {
                                                                                            handlePitched("outcome", e.target.value, ii);
                                                                                            handleInput(
                                                                                                "Outcome",
                                                                                                e.target.value,
                                                                                                "meeting_outcome",
                                                                                                e,
                                                                                                i
                                                                                            );
                                                                                          }}
                                                                                          required
                                                                                      >
                                                                                        <option value="">Select Outcome</option>
                                                                                        <option value="Verbal Confirmation">Verbal Confirmation</option>
                                                                                        <option value="Follow-up Required">Follow-up Required</option>
                                                                                        <option value="Document Collected">Document Collected</option>
                                                                                        <option value="Onboarding Done">Onboarding Done</option>
                                                                                        <option value="Not Interested">Not Interested</option>
                                                                                      </select>
                                                                                      {/* <label className="large-label float-lb">Outcome</label> */}

                                                                                    </div>
                                                                                    <div className="col-md-3">
                                                                                      <select
                                                                                          className="form-control form-control-user"
                                                                                          onChange={(e) => {handlePitched("outcomeStage", e.target.value, ii)
                                                                                            handleInput(
                                                                                                "Outcome Stage",
                                                                                                e.target.value,
                                                                                                "meeting_outcome",
                                                                                                e,
                                                                                                i
                                                                                            );
                                                                                          }}
                                                                                          required
                                                                                      >
                                                                                        <option value="">Select Meeting Outcome Stage</option>
                                                                                        <option value="Hot">Hot</option>
                                                                                        <option value="Warm">Warm</option>
                                                                                        <option value="Cold">Cold</option>
                                                                                      </select>

                                                                                      {/* <label className="large-label float-lb">Outcome Stage</label> */}
                                                                                    </div>
                                                                                    <div className="col-md-3">
                                                                                      <input
                                                                                          type="text"
                                                                                          className="form-control form-control-user"
                                                                                          placeholder="Remark"
                                                                                          onChange={(e) => handlePitched("remark", e.target.value, ii)}
                                                                                      />
                                                                                    </div>
                                                                                    {pitched[ii].outcome === "Not Interested" && (
                                                                                        <div className="col-sm-6 mt-1 float-field" style={{ marginTop: "16px !important" }}>
                                                                                          <select
                                                                                              className="form-control form-control-user"
                                                                                              onChange={(e) => {
                                                                                                handlePitched("reasonNotInterested", e.target.value, ii)
                                                                                                // handleInput("Reason for Not Interested", e.target.value, "meeting_outcome", e, ii);
                                                                                                // handleWorkingWithCompetition(ii, e.target.value);
                                                                                              }}
                                                                                              required
                                                                                          >
                                                                                            <option value="">Select Reason for Not Interested</option>
                                                                                            <option value="Working With Competition">Working With Competition</option>
                                                                                            <option value="Negative Market Feedback">Negative Market Feedback</option>
                                                                                            <option value="Other">Other</option>
                                                                                          </select>
                                                                                          <label className="large-label float-lb">Reason for Not Interested</label>
                                                                                        </div>
                                                                                    )}

                                                                                    {pitched[ii].outcome === "Not Interested" && pitched[ii].reasonNotInterested === "Working With Competition" && (
                                                                                        <>
                                                                                          <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                                                            <input
                                                                                                type="text"
                                                                                                className="form-control form-control-user"
                                                                                                placeholder=" "
                                                                                                onChange={(e) =>
                                                                                                    handlePitched("competitorName", e.target.value, ii)
                                                                                                }
                                                                                                required
                                                                                            />
                                                                                            <label className="large-label float-lb">Competitor Name</label>
                                                                                          </div>
                                                                                          <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                                                            <input
                                                                                                type="number"
                                                                                                className="form-control form-control-user"
                                                                                                placeholder=" "
                                                                                                onChange={(e) =>
                                                                                                    handlePitched("tagCost", e.target.value, ii)
                                                                                                }
                                                                                                required
                                                                                            />
                                                                                            <label className="large-label float-lb">Tag Cost</label>
                                                                                          </div>
                                                                                          <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                                                            <input
                                                                                                type="text"
                                                                                                className="form-control form-control-user"
                                                                                                placeholder=" "
                                                                                                onChange={(e) =>
                                                                                                    handlePitched("payout", e.target.value, ii)
                                                                                                }
                                                                                                required
                                                                                            />
                                                                                            <label className="large-label float-lb">Payout</label>
                                                                                          </div>
                                                                                          <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                                                            <input
                                                                                                type="text"
                                                                                                className="form-control form-control-user"
                                                                                                placeholder=" "
                                                                                                onChange={(e) =>
                                                                                                    handlePitched("activationProcess", e.target.value, ii)
                                                                                                }
                                                                                                required
                                                                                            />
                                                                                            <label className="large-label float-lb">Activation Process</label>
                                                                                          </div>
                                                                                        </>
                                                                                    )}
                                                                                  </div>
                                                                                </>
                                                                            ))}
                                                                            <div className="form-group row">
                                                                              <div className="col-md-12 text-right">
                                                                                {pitched.length !== 1 && (
                                                                                    <button
                                                                                        onClick={(e) => handleRemovePitched(e, pitched.length - 1)}
                                                                                        className="btn btn-sm btn-danger ml-3"
                                                                                    >
                                                                                      Remove Pitched
                                                                                    </button>
                                                                                )}
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-sm btn-primary ml-3"
                                                                                    onClick={() => handleAddPitched()}
                                                                                >
                                                                                  Add Pitched
                                                                                </button>
                                                                              </div>
                                                                            </div>
                                                                          </div>
                                                                        </div>
                                                                    )}





                                                                  </>
                                                              )}

                                                              {/*{isClosureStage === 'Closure' &&*/}
                                                              {/*    <div*/}
                                                              {/*        className="col-sm-6 mtk-1 float-field mb-3">*/}
                                                              {/*        <FileUpload*/}
                                                              {/*            id={"addAttachment"}*/}
                                                              {/*            accept=".png,.jpg,.jpeg"*/}
                                                              {/*            documentUploadUrl={documentUploadUrlPublic}*/}
                                                              {/*            documentUrlData={documentUrlDataPublic}*/}
                                                              {/*            onChange={(e, val) => {*/}
                                                              {/*                handleInput('client_stage', e, 'Document', e, i)*/}
                                                              {/*            }}*/}
                                                              {/*            prefilledFilename={""}*/}
                                                              {/*            multiple={true}*/}
                                                              {/*            required={true}*/}
                                                              {/*        >*/}
                                                              {/*            Closure Attachment*/}
                                                              {/*        </FileUpload>*/}
                                                              {/*    </div>*/}
                                                              {/*}*/}

                                                              {(val?.visit_purpose ===
                                                                  "Service Visit" ||
                                                                  val?.visit_purpose ===
                                                                  "Service Dealer") && (
                                                                  <>
                                                                    {pitchedService.map(
                                                                        (values, ii) => {
                                                                          return (
                                                                              <>
                                                                                <div className="col-md-6 float-field mtk-075 d-mtk-2">
                                                                                  <select
                                                                                      className="form-control form-control-user"
                                                                                      onChange={(
                                                                                          e
                                                                                      ) => {
                                                                                        handlePitchedService(
                                                                                            "pitched",
                                                                                            e.target
                                                                                                .value,
                                                                                            ii
                                                                                        );
                                                                                      }}
                                                                                      required
                                                                                  >
                                                                                    <option value="">
                                                                                      Select Service
                                                                                    </option>
                                                                                    <option
                                                                                        value={
                                                                                          "FASTag"
                                                                                        }
                                                                                    >
                                                                                      FASTag
                                                                                    </option>
                                                                                    <option
                                                                                        value={
                                                                                          "Yard Management"
                                                                                        }
                                                                                    >
                                                                                      Yard
                                                                                      Management
                                                                                    </option>
                                                                                    <option
                                                                                        value={"Fuel"}
                                                                                    >
                                                                                      Fuel
                                                                                    </option>
                                                                                    <option
                                                                                        value={
                                                                                          "Test Drive Leads"
                                                                                        }
                                                                                    >
                                                                                      Test Drive
                                                                                      Leads
                                                                                    </option>
                                                                                    <option
                                                                                        value={
                                                                                          "Driver Management"
                                                                                        }
                                                                                    >
                                                                                      Driver
                                                                                      Management
                                                                                    </option>

                                                                                  </select>
                                                                                  <label className="large-label float-lb">
                                                                                    Service Visit
                                                                                    For
                                                                                  </label>
                                                                                </div>

                                                                                {(pitchedService[ii]?.pitched === "FASTag" ||
                                                                                    pitchedService[ii]?.pitched === "Yard Management" ||
                                                                                    pitchedService[ii]?.pitched === "Fuel") && (
                                                                                    <div
                                                                                        className="col-sm-6 mt-1 float-field"
                                                                                        style={{
                                                                                          marginTop:
                                                                                              "16px !important",
                                                                                        }}
                                                                                    >
                                                                                      <select
                                                                                          className="form-control form-control-user"
                                                                                          onChange={(e) => {
                                                                                            // handleInput(
                                                                                            //   "pitched",
                                                                                            //   e.target.value,
                                                                                            //   "stage",
                                                                                            //   e,
                                                                                            //   i
                                                                                            // );
                                                                                            handlePitchedService(
                                                                                                "stage",
                                                                                                e.target
                                                                                                    .value,
                                                                                                ii
                                                                                            );

                                                                                          }}
                                                                                          required={true}
                                                                                      >
                                                                                        <option value="">
                                                                                          Select Purpose
                                                                                        </option>
                                                                                        <option
                                                                                            value={
                                                                                              "Order/Payment"
                                                                                            }
                                                                                        >
                                                                                          Order/Payment
                                                                                        </option>
                                                                                        <option
                                                                                            value={
                                                                                              "Issuance push"
                                                                                            }
                                                                                        >
                                                                                          Issuance push
                                                                                        </option>
                                                                                        <option
                                                                                            value={
                                                                                              "Regular Relationship visit"
                                                                                            }
                                                                                        >
                                                                                          Regular Relationship
                                                                                          visit
                                                                                        </option>
                                                                                        <option
                                                                                            value={
                                                                                              "Resolution call"
                                                                                            }
                                                                                        >
                                                                                          Resolution call
                                                                                        </option>
                                                                                        <option
                                                                                            value={
                                                                                              "Training call"
                                                                                            }
                                                                                        >
                                                                                          Training call
                                                                                        </option>

                                                                                      </select>
                                                                                      <label className="large-label float-lb">
                                                                                        Purpose Of Visit
                                                                                      </label>
                                                                                    </div>
                                                                                )}

                                                                                {(pitchedService[ii]?.pitched === "Driver Management") && (
                                                                                    <div
                                                                                        className="col-sm-6 mt-1 float-field"
                                                                                        style={{
                                                                                          marginTop:
                                                                                              "16px !important",
                                                                                        }}
                                                                                    >
                                                                                      <select
                                                                                          className="form-control form-control-user"
                                                                                          onChange={(e) => {
                                                                                            // handleInput(
                                                                                            //   "pitched",
                                                                                            //   e.target.value,
                                                                                            //   "stage",
                                                                                            //   e,
                                                                                            //   i
                                                                                            // );
                                                                                            handlePitchedService(
                                                                                                "stage",
                                                                                                e.target
                                                                                                    .value,
                                                                                                ii
                                                                                            );

                                                                                          }}
                                                                                          required={true}
                                                                                      >
                                                                                        <option value="">
                                                                                          Select Purpose
                                                                                        </option>
                                                                                        <option
                                                                                            value={
                                                                                              "Order/Payment"
                                                                                            }
                                                                                        >
                                                                                          Order/Payment
                                                                                        </option>
                                                                                        <option
                                                                                            value={
                                                                                              "Regular Relationship visit"
                                                                                            }
                                                                                        >
                                                                                          Regular Relationship
                                                                                          visit
                                                                                        </option>
                                                                                        <option
                                                                                            value={
                                                                                              "Resolution call"
                                                                                            }
                                                                                        >
                                                                                          Resolution call
                                                                                        </option>
                                                                                      </select>
                                                                                      <label className="large-label float-lb">
                                                                                        Purpose Of Visit
                                                                                      </label>
                                                                                    </div>
                                                                                )}

                                                                                {(pitchedService[ii]?.pitched === "Test Drive Leads") && (
                                                                                    <div
                                                                                        className="col-sm-6 mt-1 float-field"
                                                                                        style={{
                                                                                          marginTop:
                                                                                              "16px !important",
                                                                                        }}
                                                                                    >
                                                                                      <select
                                                                                          className="form-control form-control-user"
                                                                                          onChange={(e) => {
                                                                                            // handleInput(
                                                                                            //   "pitched",
                                                                                            //   e.target.value,
                                                                                            //   "stage",
                                                                                            //   e,
                                                                                            //   i
                                                                                            // );
                                                                                            handlePitchedService(
                                                                                                "stage",
                                                                                                e.target
                                                                                                    .value,
                                                                                                ii
                                                                                            );
                                                                                          }}
                                                                                          required={true}
                                                                                      >
                                                                                        <option value="">
                                                                                          Select Purpose
                                                                                        </option>
                                                                                        <option
                                                                                            value={
                                                                                              "Order/Payment"
                                                                                            }
                                                                                        >
                                                                                          Order/Payment
                                                                                        </option>
                                                                                        <option
                                                                                            value={
                                                                                              "Regular Relationship visit"
                                                                                            }
                                                                                        >
                                                                                          Regular Relationship
                                                                                          visit
                                                                                        </option>
                                                                                        <option
                                                                                            value={
                                                                                              "Resolution call"
                                                                                            }
                                                                                        >
                                                                                          Resolution call
                                                                                        </option>
                                                                                        <option
                                                                                            value={
                                                                                              "Training call"
                                                                                            }
                                                                                        >
                                                                                          Training call
                                                                                        </option>
                                                                                        <option
                                                                                            value={
                                                                                              "Lead Feedback Collection"
                                                                                            }
                                                                                        >
                                                                                          Lead Feedback Collection
                                                                                        </option>
                                                                                      </select>
                                                                                      <label className="large-label float-lb">
                                                                                        Purpose Of Visit
                                                                                      </label>
                                                                                    </div>
                                                                                )}

                                                                                {/* <div className="col-sm-6 mt-1 float-field">
                                                              <select
                                                                className="form-control form-control-user"
                                                                onChange={(
                                                                  e
                                                                ) => {
                                                                  handlePitchedService(
                                                                    "status",
                                                                    e.target
                                                                      .value,
                                                                    ii
                                                                  );
                                                                }}
                                                                required
                                                              >
                                                                <option value="">
                                                                  Select Status
                                                                </option>
                                                                <option
                                                                  value={"Hot"}
                                                                >
                                                                  Hot
                                                                </option>
                                                                <option
                                                                  value={"Warm"}
                                                                >
                                                                  Warm
                                                                </option>
                                                                <option
                                                                  value={"Cold"}
                                                                >
                                                                  Cold
                                                                </option>
                                                              </select>
                                                              <label className="large-label float-lb">
                                                                Status
                                                              </label>
                                                            </div> */}
                                                                                <div className="btn-box mb-2">
                                                                                  {pitchedService.length !==
                                                                                      1 && (
                                                                                          <>
                                                                                            <button
                                                                                                onClick={(
                                                                                                    e
                                                                                                ) =>
                                                                                                    handleRemovePitchedService(
                                                                                                        e,
                                                                                                        ii
                                                                                                    )
                                                                                                }
                                                                                                className="btn btn-sm btn-danger ml-3 btn-ar"
                                                                                            >
                                                                                              Remove
                                                                                              Pitched
                                                                                            </button>
                                                                                          </>
                                                                                      )}
                                                                                  {pitchedService.length -
                                                                                      1 ===
                                                                                      ii && (
                                                                                          <button
                                                                                              type="button"
                                                                                              className="btn btn-sm btn-primary ml-3 btn-ar"
                                                                                              onClick={() =>
                                                                                                  handleAddPitchedService(ii)
                                                                                              }
                                                                                          >
                                                                                            Add Pitched
                                                                                          </button>
                                                                                      )}
                                                                                </div>
                                                                              </>
                                                                          );
                                                                        }
                                                                    )}
                                                                    {/* {console.log("PitchedService:", pitchedService[0]?.pitched)} */}

                                                                    <div
                                                                        className="col-sm-6 mt-1 float-field"
                                                                        style={{
                                                                          marginTop:
                                                                              "16px !important",
                                                                        }}
                                                                    >
                                                                      <select
                                                                          className="form-control form-control-user"
                                                                          onChange={(e) => {
                                                                            handleInput(
                                                                                "Outcome",
                                                                                e.target.value,
                                                                                "meeting_outcome",
                                                                                e,
                                                                                i
                                                                            );
                                                                            handleOutcome(
                                                                                i,
                                                                                e.target.value
                                                                            );
                                                                            // setProductOutcome(e.target.value)
                                                                          }}
                                                                          required={true}
                                                                      >
                                                                        <option value="">
                                                                          Select Outcome
                                                                        </option>
                                                                        <option
                                                                            value={
                                                                              "Issued Resolved"
                                                                            }
                                                                        >
                                                                          Issued Resolved
                                                                        </option>
                                                                        <option
                                                                            value={"Order Placed"}
                                                                        >
                                                                          Order Placed
                                                                        </option>
                                                                        <option
                                                                            value={
                                                                              "Onboarding Done"
                                                                            }
                                                                        >
                                                                          Onboarding Done
                                                                        </option>
                                                                        <option
                                                                            value={
                                                                              "Training Done"
                                                                            }
                                                                        >
                                                                          Training Done
                                                                        </option>
                                                                        <option
                                                                            value={
                                                                              "Issuance Increase"
                                                                            }
                                                                        >
                                                                          Issuance Increase
                                                                        </option>
                                                                      </select>
                                                                      <label className="large-label float-lb">
                                                                        Visit Outcome
                                                                      </label>
                                                                    </div>
                                                                  </>
                                                              )}

                                                              {(val?.visit_purpose ===
                                                                  "Churn Resurrection" ||
                                                                  val?.visit_purpose ===
                                                                  "Churn Dealer") && (
                                                                  <>
                                                                    {pitchedChurn.map(
                                                                        (values, ii) => {
                                                                          return (
                                                                              <>
                                                                                <div className="col-md-6 float-field mtk-075 d-mtk-2">
                                                                                  <select
                                                                                      className="form-control form-control-user"
                                                                                      onChange={(
                                                                                          e
                                                                                      ) => {
                                                                                        handlePitchedChurn(
                                                                                            "pitched",
                                                                                            e.target
                                                                                                .value,
                                                                                            ii
                                                                                        );
                                                                                      }}
                                                                                      required
                                                                                  >
                                                                                    <option value="">
                                                                                      Select Pitched
                                                                                    </option>
                                                                                    <option
                                                                                        value={
                                                                                          "FASTag"
                                                                                        }
                                                                                    >
                                                                                      FASTag
                                                                                    </option>
                                                                                    <option
                                                                                        value={
                                                                                          "Yard Management"
                                                                                        }
                                                                                    >
                                                                                      Yard
                                                                                      Management
                                                                                    </option>
                                                                                    <option
                                                                                        value={"Fuel"}
                                                                                    >
                                                                                      Fuel
                                                                                    </option>
                                                                                    <option
                                                                                        value={
                                                                                          "Test Drive Leads"
                                                                                        }
                                                                                    >
                                                                                      Test Drive
                                                                                      Leads
                                                                                    </option>
                                                                                    <option
                                                                                        value={
                                                                                          "Driver Management"
                                                                                        }
                                                                                    >
                                                                                      Driver
                                                                                      Management
                                                                                    </option>
                                                                                    {/* <option value={"EMI Plan"}>
                                                EMI Plan
                                              </option>
                                              <option value={"Pay Plus"}>
                                                Pay Plus
                                              </option>
                                              <option value={"Pickup & Drop "}>
                                                Pickup & Drop
                                              </option> */}
                                                                                  </select>
                                                                                  <label className="large-label float-lb">
                                                                                    Pitched
                                                                                  </label>
                                                                                </div>

                                                                                {/* <div className="col-sm-6 mt-1 float-field">
                                                              <select
                                                                className="form-control form-control-user"
                                                                onChange={(
                                                                  e
                                                                ) => {
                                                                  handlePitchedChurn(
                                                                    "status",
                                                                    e.target
                                                                      .value,
                                                                    ii
                                                                  );
                                                                }}
                                                                required
                                                              >
                                                                <option value="">
                                                                  Select Status
                                                                </option>
                                                                <option
                                                                  value={"Hot"}
                                                                >
                                                                  Hot
                                                                </option>
                                                                <option
                                                                  value={"Warm"}
                                                                >
                                                                  Warm
                                                                </option>
                                                                <option
                                                                  value={"Cold"}
                                                                >
                                                                  Cold
                                                                </option>
                                                              </select>
                                                              <label className="large-label float-lb">
                                                                Status
                                                              </label>
                                                            </div> */}
                                                                                <div className="btn-box mb-2">
                                                                                  {pitchedChurn.length !==
                                                                                      1 && (
                                                                                          <>
                                                                                            <button
                                                                                                onClick={(
                                                                                                    e
                                                                                                ) =>
                                                                                                    handleRemovePitchedChurn(
                                                                                                        e,
                                                                                                        ii
                                                                                                    )
                                                                                                }
                                                                                                className="btn btn-sm btn-danger ml-3 btn-ar"
                                                                                            >
                                                                                              Remove
                                                                                              Pitched
                                                                                            </button>
                                                                                          </>
                                                                                      )}
                                                                                  {pitchedChurn.length -
                                                                                      1 ===
                                                                                      ii && (
                                                                                          <button
                                                                                              type="button"
                                                                                              className="btn btn-sm btn-primary ml-3 btn-ar"
                                                                                              onClick={() =>
                                                                                                  handleAddPitchedChurn()
                                                                                              }
                                                                                          >
                                                                                            Add Pitched
                                                                                          </button>
                                                                                      )}
                                                                                </div>
                                                                              </>
                                                                          );
                                                                        }
                                                                    )}
                                                                    <div
                                                                        className="col-sm-6 mt-1 float-field"
                                                                        style={{
                                                                          marginTop:
                                                                              "16px !important",
                                                                        }}
                                                                    >
                                                                      <select
                                                                          className="form-control form-control-user"
                                                                          onChange={(e) => {
                                                                            handleInput(
                                                                                "client_stage",
                                                                                e.target.value,
                                                                                "stage",
                                                                                e,
                                                                                i
                                                                            );
                                                                          }}
                                                                          required={true}
                                                                      >
                                                                        <option value="">
                                                                          Select Purpose
                                                                        </option>
                                                                        <option
                                                                            value={
                                                                              "Renegotiation"
                                                                            }
                                                                        >
                                                                          Renegotiation
                                                                        </option>
                                                                        <option
                                                                            value={
                                                                              "Issuance Resolution"
                                                                            }
                                                                        >
                                                                          Issuance Resolution
                                                                        </option>
                                                                      </select>
                                                                      <label className="large-label float-lb">
                                                                        Purpose Of Visit
                                                                      </label>
                                                                    </div>

                                                                    <div
                                                                        className="col-sm-6 mt-1 float-field"
                                                                        style={{
                                                                          marginTop:
                                                                              "16px !important",
                                                                        }}
                                                                    >
                                                                      <select
                                                                          className="form-control form-control-user"
                                                                          onChange={(e) => {
                                                                            handleInput(
                                                                                "Outcome",
                                                                                e.target.value,
                                                                                "meeting_outcome",
                                                                                e,
                                                                                i
                                                                            );
                                                                            handleOutcome(
                                                                                i,
                                                                                e.target.value
                                                                            );
                                                                          }}
                                                                          required={true}
                                                                      >
                                                                        <option value="">
                                                                          Select Outcome
                                                                        </option>
                                                                        <option
                                                                            value={
                                                                              "Issued Resolved, dealer will start issuance by"
                                                                            }
                                                                        >
                                                                          Issued Resolved,
                                                                          dealer will restart
                                                                        </option>
                                                                        <option
                                                                            value={
                                                                              "The Dealer Agreed On Commercial Will Resume Issuance From"
                                                                            }
                                                                        >
                                                                          The Dealer Agreed On
                                                                          Commercial Will Resume
                                                                          Issuance From
                                                                        </option>

                                                                        <option
                                                                            value={
                                                                              "Follow-up Required"
                                                                            }
                                                                        >
                                                                          Follow-up Required
                                                                        </option>
                                                                        <option
                                                                            value={
                                                                              "Not Interested"
                                                                            }
                                                                        >
                                                                          Not Interested
                                                                        </option>
                                                                      </select>
                                                                      <label className="large-label float-lb">
                                                                        Outcome Of Visit
                                                                      </label>
                                                                    </div>

                                                                    {productOutcome[i] ===
                                                                        "Follow-up Required" && (
                                                                            <div className="col-sm-6 mtk-075 float-field mb-4">
                                                        <textarea
                                                            className="form-control form-control-user"
                                                            placeholder=" Follow-up Require Remarks"
                                                            onChange={(e) => {
                                                              handleInput(
                                                                  "meta_data",
                                                                  e.target.value,
                                                                  "Follow-up Require Remark",
                                                                  e
                                                              );
                                                            }}
                                                            id="validationCustom01"
                                                            rows="4"
                                                            cols="50"
                                                            required={true}
                                                        />
                                                                              <label className="large-label float-lb">
                                                                                {/*Description*/}
                                                                              </label>
                                                                            </div>
                                                                        )}
                                                                    {(productOutcome[i] ===
                                                                        "Issued Resolved, dealer will start issuance by" ||
                                                                        productOutcome[i] ===
                                                                        "The Dealer Agreed On Commercial Will Resume Issuance From") && (
                                                                        <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                                          <input
                                                                              type="datetime-local"
                                                                              className="form-control form-control-user"
                                                                              placeholder=" "
                                                                              onChange={(e) => {
                                                                                handleInput(
                                                                                    "Outcome",
                                                                                    e.target.value,
                                                                                    "date",
                                                                                    e,
                                                                                    i
                                                                                );
                                                                              }}
                                                                              value={val?.status}
                                                                          />
                                                                          <label className="large-label float-lb">
                                                                            Date
                                                                          </label>
                                                                        </div>
                                                                    )}

                                                                    {productOutcome[i] ===
                                                                        "Not Interested" && (
                                                                            <>
                                                                              <div
                                                                                  className="col-sm-6 mt-1 float-field"
                                                                                  style={{
                                                                                    marginTop:
                                                                                        "16px !important",
                                                                                  }}
                                                                              >
                                                                                <select
                                                                                    className="form-control form-control-user"
                                                                                    onChange={(e) => {
                                                                                      handleInput(
                                                                                          "Remark",
                                                                                          e.target.value,
                                                                                          "meeting_outcome",
                                                                                          e,
                                                                                          i
                                                                                      );
                                                                                      handleWorkingWithCompetition(
                                                                                          i,
                                                                                          e.target.value
                                                                                      );
                                                                                    }}
                                                                                    required={true}
                                                                                >
                                                                                  <option value="">
                                                                                    Select Remark
                                                                                  </option>
                                                                                  <option
                                                                                      value={
                                                                                        "Working With Competition"
                                                                                      }
                                                                                  >
                                                                                    Working With
                                                                                    Competition
                                                                                  </option>
                                                                                  <option
                                                                                      value={
                                                                                        "Not Satisfied With Experience"
                                                                                      }
                                                                                  >
                                                                                    Not Satisfied With
                                                                                    Experience
                                                                                  </option>
                                                                                  <option
                                                                                      value={"Other"}
                                                                                  >
                                                                                    Other
                                                                                  </option>
                                                                                </select>
                                                                                <label className="large-label float-lb">
                                                                                  Remark
                                                                                </label>
                                                                              </div>

                                                                              {workingWithCompetition[
                                                                                      i
                                                                                      ] ===
                                                                                  "Working With Competition" && (
                                                                                      <>
                                                                                        <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                                                          <input
                                                                                              type="text"
                                                                                              className="form-control form-control-user"
                                                                                              placeholder=" "
                                                                                              onChange={(
                                                                                                  e
                                                                                              ) => {
                                                                                                handleInput(
                                                                                                    "Competitior Name",
                                                                                                    e.target
                                                                                                        .value,
                                                                                                    "meeting_outcome",
                                                                                                    e,
                                                                                                    i
                                                                                                );
                                                                                              }}
                                                                                              value={
                                                                                                val?.pitched
                                                                                              }
                                                                                          />
                                                                                          <label className="large-label float-lb">
                                                                                            Competitior Name
                                                                                          </label>
                                                                                        </div>
                                                                                        <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                                                          <input
                                                                                              type="number"
                                                                                              className="form-control form-control-user"
                                                                                              placeholder=" "
                                                                                              onChange={(
                                                                                                  e
                                                                                              ) => {
                                                                                                handleInput(
                                                                                                    "Tag Cost",
                                                                                                    e.target
                                                                                                        .value,
                                                                                                    "meeting_outcome",
                                                                                                    e,
                                                                                                    i
                                                                                                );
                                                                                              }}
                                                                                              value={
                                                                                                val?.pitched
                                                                                              }
                                                                                          />
                                                                                          <label className="large-label float-lb">
                                                                                            Tag Cost
                                                                                          </label>
                                                                                        </div>
                                                                                        <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                                                          <input
                                                                                              type="number"
                                                                                              className="form-control form-control-user"
                                                                                              placeholder=" "
                                                                                              onChange={(
                                                                                                  e
                                                                                              ) => {
                                                                                                handleInput(
                                                                                                    "Payout",
                                                                                                    e.target
                                                                                                        .value,
                                                                                                    "meeting_outcome",
                                                                                                    e,
                                                                                                    i
                                                                                                );
                                                                                              }}
                                                                                              value={
                                                                                                val?.pitched
                                                                                              }
                                                                                          />
                                                                                          <label className="large-label float-lb">
                                                                                            Payout
                                                                                          </label>
                                                                                        </div>
                                                                                        <div className="col-sm-6 col-md-3 mt-1 float-field">
                                                                                          <input
                                                                                              type="text"
                                                                                              className="form-control form-control-user"
                                                                                              placeholder=" "
                                                                                              onChange={(
                                                                                                  e
                                                                                              ) => {
                                                                                                handleInput(
                                                                                                    "Activation Process",
                                                                                                    e.target
                                                                                                        .value,
                                                                                                    "meeting_outcome",
                                                                                                    e,
                                                                                                    i
                                                                                                );
                                                                                              }}
                                                                                              value={
                                                                                                val?.pitched
                                                                                              }
                                                                                          />
                                                                                          <label className="large-label float-lb">
                                                                                            Activation
                                                                                            Process
                                                                                          </label>
                                                                                        </div>
                                                                                      </>
                                                                                  )}

                                                                              {workingWithCompetition[
                                                                                      i
                                                                                      ] ===
                                                                                  "Not Satisfied With Experience" && (
                                                                                      <div className="col-sm-6 mtk-075 float-field mb-4">
                                                            <textarea
                                                                className="form-control form-control-user"
                                                                placeholder=" Not Satisfied With Experience Remarks"
                                                                onChange={(e) => {
                                                                  handleInput(
                                                                      "Not Satisfied With Experience Remark",
                                                                      e.target
                                                                          .value,
                                                                      "meeting_outcome",
                                                                      e,
                                                                      i
                                                                  );
                                                                }}
                                                                id="validationCustom01"
                                                                rows="4"
                                                                cols="50"
                                                                required={true}
                                                            />
                                                                                        <label className="large-label float-lb">
                                                                                          {/*Description*/}
                                                                                        </label>
                                                                                      </div>
                                                                                  )}
                                                                            </>
                                                                        )}
                                                                  </>
                                                              )}

                                                              {/*{isClosureStage === 'Closure' &&*/}
                                                              {/*    <div className="col-sm-6 mt-1 float-field"*/}
                                                              {/*         style={{marginTop: "16px !important"}}*/}
                                                              {/*         required={true}*/}
                                                              {/*    >*/}
                                                              {/*        <select*/}
                                                              {/*            className="form-control form-control-user"*/}
                                                              {/*            onChange={(e) => {*/}
                                                              {/*                handleInput('client_stage', e.target.value, 'closure_stage', e, i)*/}
                                                              {/*                setClientStage(e.target.value)*/}
                                                              {/*            }}>*/}
                                                              {/*            <option value="">Select Closure Stages*/}
                                                              {/*            </option>*/}
                                                              {/*            <option value={"Warm"}>Warm</option>*/}
                                                              {/*            <option value={"Hot"}>Hot</option>*/}
                                                              {/*            <option value={"Cold"}>Cold</option>*/}
                                                              {/*        </select>*/}
                                                              {/*        <label className="large-label float-lb">*/}
                                                              {/*            Closure Stage*/}
                                                              {/*        </label>*/}
                                                              {/*    </div>*/}
                                                              {/*}*/}
                                                            </>
                                                        )}
                                                      </>
                                                  );
                                                }
                                            )}
                                        {/*{getActivityDetails?.data?.activity_type_id !== undefined &&*/}
                                        {/*    parseInt(getActivityDetails?.data?.activity_type_id) === 15 &&*/}
                                        {/*    purposeOfVisit.map((val, i) => {*/}
                                        {/*        return (*/}
                                        {/*            <>*/}
                                        {/*                <div className="col-sm-6 mt-1 float-field">*/}
                                        {/*                    <select*/}
                                        {/*                        className="form-control form-control-user"*/}
                                        {/*                        onChange={(e) => {*/}
                                        {/*                            handlePurposeOfVisit(e.target.value, i)*/}
                                        {/*                        }}*/}
                                        {/*                        required*/}
                                        {/*                    >*/}
                                        {/*                        <option value="">Select Purpose Of*/}
                                        {/*                            Visit*/}
                                        {/*                        </option>*/}
                                        {/*                        <option value={"New Product"}>New*/}
                                        {/*                            Product*/}
                                        {/*                        </option>*/}
                                        {/*                        <option*/}
                                        {/*                            value={"Service Visit"}>Service*/}
                                        {/*                            Visit*/}
                                        {/*                        </option>*/}
                                        {/*                        <option*/}
                                        {/*                            value={"Churn Resurrection"}>Churn*/}
                                        {/*                            Resurrection*/}
                                        {/*                        </option>*/}
                                        {/*                    </select>*/}
                                        {/*                    <label className="large-label float-lb">*/}
                                        {/*                        Purpose Of Visit Type*/}
                                        {/*                    </label>*/}
                                        {/*                </div>*/}

                                        {/*                {val?.visit_purpose === 'New Product' &&*/}
                                        {/*                    pitched.map((values, ii) => {*/}
                                        {/*                        return (*/}
                                        {/*                            <>*/}
                                        {/*                                <div*/}
                                        {/*                                    className="col-md-6 float-field mtk-075 d-mtk-2">*/}
                                        {/*                                    <select*/}
                                        {/*                                        className="form-control form-control-user"*/}
                                        {/*                                        onChange={(e) => {*/}
                                        {/*                                            handlePitched('pitched', e.target.value, ii)*/}
                                        {/*                                        }}*/}
                                        {/*                                        required*/}
                                        {/*                                    >*/}
                                        {/*                                        <option*/}
                                        {/*                                            value="">Select*/}
                                        {/*                                            Pitched*/}
                                        {/*                                        </option>*/}
                                        {/*                                        <option*/}
                                        {/*                                            value={"FASTag"}>FASTag*/}
                                        {/*                                        </option>*/}
                                        {/*                                        <option*/}
                                        {/*                                            value={"EMI Protect"}>EMI*/}
                                        {/*                                            Protect*/}
                                        {/*                                        </option>*/}
                                        {/*                                        <option*/}
                                        {/*                                            value={"Yard Management"}>Yard*/}
                                        {/*                                            Management*/}
                                        {/*                                        </option>*/}
                                        {/*                                        <option*/}
                                        {/*                                            value={"Service Lead"}>Service*/}
                                        {/*                                            Lead*/}
                                        {/*                                        </option>*/}
                                        {/*                                    </select>*/}
                                        {/*                                    <label*/}
                                        {/*                                        className="large-label float-lb">*/}
                                        {/*                                        Purpose Of Visit*/}
                                        {/*                                        Type*/}
                                        {/*                                    </label>*/}
                                        {/*                                </div>*/}
                                        {/*                                <div*/}
                                        {/*                                    className="col-sm-6 mt-1 float-field">*/}
                                        {/*                                    <select*/}
                                        {/*                                        className="form-control form-control-user"*/}
                                        {/*                                        onChange={(e) => {*/}
                                        {/*                                            handlePitched('status', e.target.value, ii)*/}
                                        {/*                                        }}*/}
                                        {/*                                        required*/}
                                        {/*                                    >*/}
                                        {/*                                        <option*/}
                                        {/*                                            value="">Select*/}
                                        {/*                                            Status*/}
                                        {/*                                        </option>*/}
                                        {/*                                        <option*/}
                                        {/*                                            value={"Warm"}>Warm*/}
                                        {/*                                        </option>*/}
                                        {/*                                        <option*/}
                                        {/*                                            value={"Hot"}>Hot*/}
                                        {/*                                        </option>*/}
                                        {/*                                        <option*/}
                                        {/*                                            value={"Cold"}>Cold*/}
                                        {/*                                        </option>*/}
                                        {/*                                    </select>*/}
                                        {/*                                    <label*/}
                                        {/*                                        className="large-label float-lb">*/}
                                        {/*                                        Status*/}
                                        {/*                                    </label>*/}
                                        {/*                                </div>*/}
                                        {/*                                <div*/}
                                        {/*                                    className="btn-box mb-2">*/}
                                        {/*                                    {pitched.length !== 1 &&*/}
                                        {/*                                        <>*/}
                                        {/*                                            <button*/}
                                        {/*                                                onClick={(e) => handleRemovePitched(e, ii)}*/}
                                        {/*                                                className="btn btn-sm btn-danger ml-3 btn-ar">Remove*/}
                                        {/*                                                Pitched*/}
                                        {/*                                            </button>*/}
                                        {/*                                        </>*/}
                                        {/*                                    }*/}
                                        {/*                                    {pitched.length - 1 === ii &&*/}
                                        {/*                                        <button*/}
                                        {/*                                            type="button"*/}
                                        {/*                                            className="btn btn-sm btn-primary ml-3 btn-ar"*/}
                                        {/*                                            onClick={() => handleAddPitched()}>Add*/}
                                        {/*                                            Pitched*/}
                                        {/*                                        </button>}*/}
                                        {/*                                </div>*/}
                                        {/*                            </>*/}
                                        {/*                        )*/}
                                        {/*                    })*/}
                                        {/*                }*/}
                                        {/*                <div className="btn-box mb-2">*/}
                                        {/*                    {purposeOfVisit.length !== 1 &&*/}
                                        {/*                        <>*/}
                                        {/*                            <button*/}
                                        {/*                                onClick={(e) => handleRemovePurposeOfVisit(e, i)}*/}
                                        {/*                                className="btn btn-sm btn-danger ml-3 btn-ar">Remove*/}
                                        {/*                            </button>*/}
                                        {/*                        </>*/}
                                        {/*                    }*/}
                                        {/*                    {purposeOfVisit.length - 1 === i &&*/}
                                        {/*                        <button type="button"*/}
                                        {/*                                className="btn btn-sm btn-primary ml-3 btn-ar"*/}
                                        {/*                                onClick={() => handleAddPurposeOfVisit()}>Add*/}
                                        {/*                            More*/}
                                        {/*                        </button>}*/}
                                        {/*                </div>*/}
                                        {/*            </>*/}
                                        {/*        )*/}
                                        {/*    })*/}
                                        {/*}*/}
                                        {/*<div className="col-sm-6 mtk-075 float-field mb-4">*/}
                                        {/*    <textarea*/}
                                        {/*        className="form-control form-control-user"*/}
                                        {/*        placeholder=" Remarks"*/}
                                        {/*        onChange={(e) => {*/}
                                        {/*            handleInput('meta_data', e.target.value, 'remark', e)*/}
                                        {/*        }}*/}
                                        {/*        id="validationCustom01"*/}
                                        {/*        rows="4" cols="50"*/}
                                        {/*        required={true}*/}
                                        {/*    />*/}
                                        {/*    <label className="large-label float-lb">*/}
                                        {/*        /!*Description*!/*/}
                                        {/*    </label>*/}
                                        {/*</div>*/}
                                        <>
                                          <div className="col-sm-6 mt-1 float-field">
                                            <select
                                                className="form-control form-control-user"
                                                onChange={(e) => {
                                                  setFollowupMeeting(e.target.value);
                                                }}
                                                required
                                            >
                                              <option value=""></option>
                                              <option value={"yes"}>Yes</option>
                                              <option value={"no"}>No</option>
                                            </select>
                                            <label className="large-label float-lb">
                                              Is Follow-up Meeting Required
                                            </label>
                                          </div>
                                          {followupMeeting === "yes" && (
                                              <>
                                                <div className="col-sm-6 mtk-075 float-field">
                                                  <input
                                                      type="datetime-local"
                                                      className="form-control form-control-user"
                                                      placeholder=" "
                                                      onChange={(e) => {
                                                        handleTaskInput(
                                                            "task_date",
                                                            e.target.value,
                                                            e
                                                        );
                                                      }}
                                                      required
                                                      id="validationCustom01"
                                                      min={
                                                          new Date()
                                                              .toISOString()
                                                              .split("T")[0] + "T00:00"
                                                      }
                                                      // value={getActivityDetails?.data?.activity_date !== undefined ? getActivityDetails?.data?.activity_date :""}
                                                  />
                                                  <label className="large-label float-lb">
                                                    Follow-up Meeting Date
                                                  </label>
                                                </div>
                                                {/*<div*/}
                                                {/*    className="col-sm-6 mtk-075 float-field mb-4">*/}
                                                {/*<textarea*/}
                                                {/*    className="form-control form-control-user"*/}
                                                {/*    placeholder=" Follow-up Meeting Description"*/}
                                                {/*    onChange={(e) => {*/}
                                                {/*        handleTaskInput('description', e.target.value, e)*/}
                                                {/*    }}*/}
                                                {/*    required*/}
                                                {/*    id="validationCustom01"*/}
                                                {/*    rows="4" cols="50"*/}
                                                {/*/>*/}
                                                {/*    <label className="large-label float-lb">*/}
                                                {/*        /!*Description*!/*/}
                                                {/*    </label>*/}
                                                {/*</div>*/}
                                              </>
                                          )}
                                          {/*<div*/}
                                          {/*    className="col-sm-6 mtk-075 float-field">*/}
                                          {/*    <input type="datetime-local"*/}
                                          {/*           className="form-control form-control-user"*/}
                                          {/*           placeholder=" "*/}
                                          {/*           onChange={(e) => {*/}
                                          {/*               handleInput('closure_date', e.target.value, '', e)*/}
                                          {/*           }}*/}
                                          {/*           id="validationCustom01"*/}
                                          {/*           required*/}
                                          {/*        // value={getActivityDetails?.data?.activity_date !== undefined ? getActivityDetails?.data?.activity_date :""}*/}
                                          {/*    />*/}
                                          {/*    <label className="large-label float-lb">*/}
                                          {/*        Closure Date*/}
                                          {/*    </label>*/}
                                          {/*</div>*/}
                                          {/*<div*/}
                                          {/*    className="col-sm-6 mtk-075 float-field">*/}
                                          {/*    <input type="datetime-local"*/}
                                          {/*           className="form-control form-control-user"*/}
                                          {/*           placeholder=" "*/}
                                          {/*           onChange={(e) => {*/}
                                          {/*               handleInput('meta_data', e.target.value, 'payment_date', e)*/}
                                          {/*           }}*/}
                                          {/*           id="validationCustom01"*/}
                                          {/*           required*/}
                                          {/*        // value={getActivityDetails?.data?.activity_date !== undefined ? getActivityDetails?.data?.activity_date :""}*/}
                                          {/*    />*/}
                                          {/*    <label className="large-label float-lb">*/}
                                          {/*        Payment Date*/}
                                          {/*    </label>*/}
                                          {/*</div>*/}
                                          <div className="row b-13">
                                            <div className="form-check form-switch global-search">
                                              <input type="checkbox" style={{height:"22px !important", width:"20px"}}
                                                  //  onChange={(e) => handleTaskInput(e.target.checked)}
                                                     onChange={(e) => {
                                                       handleInput(
                                                           "meta_data",
                                                           e.target.checked,
                                                           "checked",
                                                           e
                                                       );
                                                     }}
                                              />
                                              {/*<label className="radio-btn" for="switch">Global Search</label>*/}
                                              <span className="serach-title" style={{ marginTop:"12px"}}>Made me wait for more than 15 mins</span>
                                            </div>
                                            <br />
                                            <br />
                                          </div>
                                        </>
                                        <textarea
                                            className="form-control form-control-user"
                                            placeholder="Client Communication"
                                            onChange={(e) => handleInput("meta_data", e.target.value, "client_communication", e)}
                                            id="validationCustom01"
                                            rows="5"
                                            cols="20"
                                        ></textarea>

                                        <textarea
                                            className="form-control form-control-user"
                                            placeholder="MOM"
                                            onChange={(e) => handleInput("meta_data", e.target.value, "MOM", e)}
                                            required
                                            id="validationCustom01"
                                            rows="4"
                                            cols="50"
                                        ></textarea>
                                        {/*{parseInt(getActivityDetails?.data?.activity_type_id) === 16 &&*/}
                                        {/*    <>*/}
                                        {/*        <div className="col-sm-6 mt-1 float-field"*/}
                                        {/*             style={{marginTop: "16px !important"}}>*/}
                                        {/*            <select*/}
                                        {/*                className="form-control form-control-user"*/}
                                        {/*                onChange={(e) => {*/}
                                        {/*                    handleInput('client_stage', e.target.value, 'client', e)*/}
                                        {/*                    setClientStage(e.target.value)*/}
                                        {/*                }}>*/}
                                        {/*                <option value="">Select Client Stage*/}
                                        {/*                </option>*/}
                                        {/*                <option value={"New Product"}>New Product*/}
                                        {/*                </option>*/}
                                        {/*                <option value={"Service"}>Service</option>*/}
                                        {/*                <option value={"Churn"}>Churn</option>*/}
                                        {/*            </select>*/}
                                        {/*            <label className="large-label float-lb">*/}
                                        {/*                Client Stage*/}
                                        {/*            </label>*/}
                                        {/*        </div>*/}

                                        {/*        {clientStage === 'New Product' &&*/}
                                        {/*            <div className="col-sm-6 mt-1 float-field"*/}
                                        {/*                 style={{marginTop: "16px !important"}}>*/}
                                        {/*                <select*/}
                                        {/*                    className="form-control form-control-user"*/}
                                        {/*                    onChange={(e) => {*/}
                                        {/*                        handleInput('client_stage', e.target.value, 'stage', e)*/}
                                        {/*                        setIsClosureStage(e.target.value)*/}
                                        {/*                    }}>*/}
                                        {/*                    <option value="">Select New Product*/}
                                        {/*                        Stages*/}
                                        {/*                    </option>*/}
                                        {/*                    <option*/}
                                        {/*                        value={"Initial Conversation"}>Initial*/}
                                        {/*                        Conversation*/}
                                        {/*                    </option>*/}
                                        {/*                    <option*/}
                                        {/*                        value={"Negotiation"}>Negotiation*/}
                                        {/*                    </option>*/}
                                        {/*                    <option*/}
                                        {/*                        value={"Documents Signed"}>Documents*/}
                                        {/*                        Signed*/}
                                        {/*                    </option>*/}
                                        {/*                    <option value={"Closure"}>Closure*/}
                                        {/*                    </option>*/}
                                        {/*                </select>*/}
                                        {/*                <label className="large-label float-lb">*/}
                                        {/*                    New Product Stages*/}
                                        {/*                </label>*/}
                                        {/*            </div>*/}
                                        {/*        }*/}

                                        {/*        {isClosureStage === 'Closure' &&*/}
                                        {/*            <div*/}
                                        {/*                className="col-sm-6 mtk-1 float-field mb-3">*/}
                                        {/*                <FileUpload*/}
                                        {/*                    id={"addAttachment"}*/}
                                        {/*                    accept=".png,.jpg,.jpeg"*/}
                                        {/*                    documentUploadUrl={documentUploadUrlPublic}*/}
                                        {/*                    documentUrlData={documentUrlDataPublic}*/}
                                        {/*                    onChange={(e, val) => {*/}
                                        {/*                        handleInput('client_stage', e, 'Document', e)*/}
                                        {/*                    }}*/}
                                        {/*                    prefilledFilename={""}*/}
                                        {/*                    multiple={true}*/}
                                        {/*                >*/}
                                        {/*                    Closure Attachment*/}
                                        {/*                </FileUpload>*/}
                                        {/*            </div>*/}
                                        {/*        }*/}

                                        {/*        {clientStage === 'Service' &&*/}
                                        {/*            <div className="col-sm-6 mt-1 float-field"*/}
                                        {/*                 style={{marginTop: "16px !important"}}>*/}
                                        {/*                <select*/}
                                        {/*                    className="form-control form-control-user"*/}
                                        {/*                    onChange={(e) => {*/}
                                        {/*                        handleInput('client_stage', e.target.value, 'stage', e)*/}
                                        {/*                    }}>*/}
                                        {/*                    <option value="">Select Service Stages*/}
                                        {/*                    </option>*/}
                                        {/*                    <option*/}
                                        {/*                        value={"Order/Payment"}>Order/Payment*/}
                                        {/*                    </option>*/}
                                        {/*                    <option value={"Issuance push"}>Issuance*/}
                                        {/*                        push*/}
                                        {/*                    </option>*/}
                                        {/*                    <option*/}
                                        {/*                        value={"Resolution call"}>Resolution*/}
                                        {/*                        call*/}
                                        {/*                    </option>*/}
                                        {/*                    <option*/}
                                        {/*                        value={"Regular Relationship visit"}>Regular*/}
                                        {/*                        Relationship visit*/}
                                        {/*                    </option>*/}
                                        {/*                </select>*/}
                                        {/*                <label className="large-label float-lb">*/}
                                        {/*                    Service Stages*/}
                                        {/*                </label>*/}
                                        {/*            </div>*/}
                                        {/*        }*/}

                                        {/*        {clientStage === 'Churn' &&*/}
                                        {/*            <div className="col-sm-6 mt-1 float-field"*/}
                                        {/*                 style={{marginTop: "16px !important"}}>*/}
                                        {/*                <select*/}
                                        {/*                    className="form-control form-control-user"*/}
                                        {/*                    onChange={(e) => {*/}
                                        {/*                        handleInput('client_stage', e.target.value, 'stage', e)*/}
                                        {/*                    }}>*/}
                                        {/*                    <option value="">Select Churn Stages*/}
                                        {/*                    </option>*/}
                                        {/*                    <option*/}
                                        {/*                        value={"Follow-Ups"}>Follow-Ups*/}
                                        {/*                    </option>*/}
                                        {/*                    <option*/}
                                        {/*                        value={"Issuance Resolution"}>Issuance*/}
                                        {/*                        Resolution*/}
                                        {/*                    </option>*/}
                                        {/*                </select>*/}
                                        {/*                <label className="large-label float-lb">*/}
                                        {/*                    Churn Stages*/}
                                        {/*                </label>*/}
                                        {/*            </div>*/}
                                        {/*        }*/}

                                        {/*        {isClosureStage === 'Closure' &&*/}
                                        {/*            <div className="col-sm-6 mt-1 float-field"*/}
                                        {/*                 style={{marginTop: "16px !important"}}>*/}
                                        {/*                <select*/}
                                        {/*                    className="form-control form-control-user"*/}
                                        {/*                    onChange={(e) => {*/}
                                        {/*                        handleInput('closure_stage', e.target.value, 'closure_stage', e)*/}
                                        {/*                        setClientStage(e.target.value)*/}
                                        {/*                    }}>*/}
                                        {/*                    <option value="">Select Closure Stages*/}
                                        {/*                    </option>*/}
                                        {/*                    <option value={"Warm"}>Warm</option>*/}
                                        {/*                    <option value={"Hot"}>Hot</option>*/}
                                        {/*                    <option value={"Cold"}>Cold</option>*/}
                                        {/*                </select>*/}
                                        {/*                <label className="large-label float-lb">*/}
                                        {/*                    Closure Stage*/}
                                        {/*                </label>*/}
                                        {/*            </div>*/}
                                        {/*        }*/}
                                        {/*    </>*/}
                                        {/*}*/}
                                        <div className="col-sm-12 mtk-1 float-field mb-3">
                                          <FileUpload
                                              id={"addAttachment"}
                                              accept=".png,.jpg,.jpeg"
                                              documentUploadUrl={
                                                documentUploadUrlPublic
                                              }
                                              documentUrlData={documentUrlDataPublic}
                                              onChange={(e, val) => {
                                                handleInput(
                                                    "meta_data",
                                                    e,
                                                    "Document",
                                                    e
                                                );
                                              }}
                                              prefilledFilename={""}
                                              multiple={true}
                                          >
                                            File Attachment
                                          </FileUpload>
                                        </div>
                                        <div className="col-sm-12 mtk-1 float-field mb-3">
                                          <FileUpload
                                              id={"addClientAttachment"}
                                              accept=".png,.jpg,.jpeg,.pdf,.doc"
                                              documentUploadUrl={
                                                documentUploadUrlPublic
                                              }
                                              documentUrlData={documentUrlDataPublic}
                                              onChange={(e, val) => {
                                                handleInput(
                                                    "meta_data",
                                                    e,
                                                    "client_document",
                                                    e
                                                );
                                              }}
                                              prefilledFilename={""}
                                              multiple={true}
                                          >
                                            Client Attachment
                                          </FileUpload>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {/*</div>*/}
                                  <div className="col-md-12 mt-4 d-flex">
                                    <button className="btn btn-primary btn-user btn-block submit-btn">
                                      Submit
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </>
                      )}
                    </>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
  );
};

export default CompleteActivity;
